import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  isNaNymqb93xtq8w8 as isNaN_0,
  to2cs3ny02qtbcb as to,
  Enum3alwj03lh1n41 as Enum,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  Signal3nnez3346azzf as Signal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  get_fast37cu8s8qwnuyi as get_fast,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_14,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_15,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_16,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_17,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_18,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_19,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_20,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_22,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  If1av5krmfyt44s as If,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Program1hnygp9hph4ry as Program,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_23,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_24,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_25,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_26,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_27,
  Rectangle3q03woyn9k8x1 as Rectangle,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_28,
  Scale2cm697xlulcp5 as Scale,
  Circle1sk1qi5ph1m23 as Circle,
  Companion_getInstance2yu48324co92b as Companion_getInstance_29,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_30,
  RoundRectangle271svjyf7w51p as RoundRectangle,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_31,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_33,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_34,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  toShape2D2vgft60vvvqgq as toShape2D,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  MMatrix1y71lv7vv6y8t as MMatrix,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_35,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.a9d_1 = Companion_getInstance_0().c1h('Korge');
    this.b9d_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  c9d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.c9d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.o9b_1 = this$0;
    this.p9b_1 = $entry;
  }
  h1b($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_36();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_36().b9d_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().n84_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().y81_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_37().j3o() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().n3x_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().m3x_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.q9b_1 = args;
    this.r9b_1 = imageFormats;
    this.s9b_1 = gameWindow;
    this.t9b_1 = mainSceneClass;
    this.u9b_1 = timeProvider;
    this.v9b_1 = injector;
    this.w9b_1 = configInjector;
    this.x9b_1 = debug;
    this.y9b_1 = trace;
    this.z9b_1 = context;
    this.a9c_1 = fullscreen;
    this.b9c_1 = blocking;
    this.c9c_1 = gameId;
    this.d9c_1 = settingsFolder;
    this.e9c_1 = batchMaxQuads;
    this.f9c_1 = windowSize;
    this.g9c_1 = virtualSize;
    this.h9c_1 = displayMode;
    this.i9c_1 = title;
    this.j9c_1 = backgroundColor;
    this.k9c_1 = quality;
    this.l9c_1 = icon;
    this.m9c_1 = multithreaded;
    this.n9c_1 = forceRenderEveryFrame;
    this.o9c_1 = windowCreationConfig;
    this.p9c_1 = main;
    this.q9c_1 = debugAg;
    this.r9c_1 = debugFontExtraScale;
    this.s9c_1 = debugFontColor;
    this.t9c_1 = stageBuilder;
    this.u9c_1 = targetFps;
    this.v9c_1 = preferSyncIo;
    this.w9c_1 = debugCoroutines;
    this.x9c_1 = unit;
  }
  x9f(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  y9f(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  y9c(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.q9b_1 : args;
    imageFormats = imageFormats === VOID ? this.r9b_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.s9b_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.t9b_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.u9b_1 : timeProvider;
    injector = injector === VOID ? this.v9b_1 : injector;
    configInjector = configInjector === VOID ? this.w9b_1 : configInjector;
    debug = debug === VOID ? this.x9b_1 : debug;
    trace = trace === VOID ? this.y9b_1 : trace;
    context = context === VOID ? this.z9b_1 : context;
    fullscreen = fullscreen === VOID ? this.a9c_1 : fullscreen;
    blocking = blocking === VOID ? this.b9c_1 : blocking;
    gameId = gameId === VOID ? this.c9c_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.d9c_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.e9c_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.f9c_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.g9c_1 : virtualSize;
    displayMode = displayMode === VOID ? this.h9c_1 : displayMode;
    title = title === VOID ? this.i9c_1 : title;
    backgroundColor = backgroundColor === VOID ? this.j9c_1 : backgroundColor;
    quality = quality === VOID ? this.k9c_1 : quality;
    icon = icon === VOID ? this.l9c_1 : icon;
    multithreaded = multithreaded === VOID ? this.m9c_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.n9c_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.o9c_1 : windowCreationConfig;
    main = main === VOID ? this.p9c_1 : main;
    debugAg = debugAg === VOID ? this.q9c_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.r9c_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.s9c_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.t9c_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.u9c_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.v9c_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.w9c_1 : debugCoroutines;
    unit = unit === VOID ? this.x9c_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.y9f(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.y9f;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.q9b_1);
    var tmp_0 = this.r9b_1.toString();
    var tmp_1 = toString_0(this.s9b_1);
    var tmp_2 = toString_0(this.t9b_1);
    var tmp_3 = toString(this.u9b_1);
    var tmp_4 = this.v9b_1.toString();
    var tmp_5 = toString(this.w9b_1);
    var tmp_6 = toString_0(this.z9b_1);
    var tmp_7 = this.f9c_1.toString();
    var tmp_8 = this.g9c_1.toString();
    var tmp_9 = this.h9c_1.toString();
    var tmp_10 = this.j9c_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.x9b_1 + ', trace=' + this.y9b_1 + ', context=' + tmp_6 + ', fullscreen=' + this.a9c_1 + ', blocking=' + this.b9c_1 + ', gameId=' + this.c9c_1 + ', settingsFolder=' + this.d9c_1 + ', batchMaxQuads=' + this.e9c_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.i9c_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.k9c_1) + ', icon=' + this.l9c_1 + ', multithreaded=' + this.m9c_1 + ', forceRenderEveryFrame=' + this.n9c_1 + ', windowCreationConfig=' + this.o9c_1.toString() + ', main=' + toString(this.p9c_1) + ', debugAg=' + this.q9c_1 + ', debugFontExtraScale=' + this.r9c_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.s9c_1) + ', stageBuilder=' + toString(this.t9c_1) + ', targetFps=' + this.u9c_1 + ', preferSyncIo=' + this.v9c_1 + ', debugCoroutines=' + this.w9c_1 + ', unit=' + this.x9c_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.q9b_1);
    result = imul(result, 31) + hashCode(this.r9b_1) | 0;
    result = imul(result, 31) + (this.s9b_1 == null ? 0 : hashCode(this.s9b_1)) | 0;
    result = imul(result, 31) + (this.t9b_1 == null ? 0 : this.t9b_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.u9b_1) | 0;
    result = imul(result, 31) + hashCode(this.v9b_1) | 0;
    result = imul(result, 31) + hashCode(this.w9b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x9b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y9b_1) | 0;
    result = imul(result, 31) + (this.z9b_1 == null ? 0 : hashCode(this.z9b_1)) | 0;
    result = imul(result, 31) + (this.a9c_1 == null ? 0 : getBooleanHashCode(this.a9c_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b9c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c9c_1) | 0;
    result = imul(result, 31) + (this.d9c_1 == null ? 0 : getStringHashCode(this.d9c_1)) | 0;
    result = imul(result, 31) + this.e9c_1 | 0;
    result = imul(result, 31) + this.f9c_1.hashCode() | 0;
    result = imul(result, 31) + this.g9c_1.hashCode() | 0;
    result = imul(result, 31) + this.h9c_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.i9c_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.j9c_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.j9c_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.k9c_1.hashCode() | 0;
    result = imul(result, 31) + (this.l9c_1 == null ? 0 : getStringHashCode(this.l9c_1)) | 0;
    result = imul(result, 31) + (this.m9c_1 == null ? 0 : getBooleanHashCode(this.m9c_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n9c_1) | 0;
    result = imul(result, 31) + this.o9c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p9c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q9c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r9c_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.s9c_1) | 0;
    result = imul(result, 31) + hashCode(this.t9c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u9c_1) | 0;
    result = imul(result, 31) + (this.v9c_1 == null ? 0 : getBooleanHashCode(this.v9c_1)) | 0;
    result = imul(result, 31) + (this.w9c_1 == null ? 0 : getBooleanHashCode(this.w9c_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.q9b_1, tmp0_other_with_cast.q9b_1))
      return false;
    if (!equals(this.r9b_1, tmp0_other_with_cast.r9b_1))
      return false;
    if (!equals(this.s9b_1, tmp0_other_with_cast.s9b_1))
      return false;
    if (!equals(this.t9b_1, tmp0_other_with_cast.t9b_1))
      return false;
    if (!equals(this.u9b_1, tmp0_other_with_cast.u9b_1))
      return false;
    if (!equals(this.v9b_1, tmp0_other_with_cast.v9b_1))
      return false;
    if (!equals(this.w9b_1, tmp0_other_with_cast.w9b_1))
      return false;
    if (!(this.x9b_1 === tmp0_other_with_cast.x9b_1))
      return false;
    if (!(this.y9b_1 === tmp0_other_with_cast.y9b_1))
      return false;
    if (!equals(this.z9b_1, tmp0_other_with_cast.z9b_1))
      return false;
    if (!(this.a9c_1 == tmp0_other_with_cast.a9c_1))
      return false;
    if (!(this.b9c_1 === tmp0_other_with_cast.b9c_1))
      return false;
    if (!(this.c9c_1 === tmp0_other_with_cast.c9c_1))
      return false;
    if (!(this.d9c_1 == tmp0_other_with_cast.d9c_1))
      return false;
    if (!(this.e9c_1 === tmp0_other_with_cast.e9c_1))
      return false;
    if (!this.f9c_1.equals(tmp0_other_with_cast.f9c_1))
      return false;
    if (!this.g9c_1.equals(tmp0_other_with_cast.g9c_1))
      return false;
    if (!this.h9c_1.equals(tmp0_other_with_cast.h9c_1))
      return false;
    if (!(this.i9c_1 === tmp0_other_with_cast.i9c_1))
      return false;
    var tmp = this.j9c_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.j9c_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.k9c_1.equals(tmp0_other_with_cast.k9c_1))
      return false;
    if (!(this.l9c_1 == tmp0_other_with_cast.l9c_1))
      return false;
    if (!(this.m9c_1 == tmp0_other_with_cast.m9c_1))
      return false;
    if (!(this.n9c_1 === tmp0_other_with_cast.n9c_1))
      return false;
    if (!this.o9c_1.equals(tmp0_other_with_cast.o9c_1))
      return false;
    if (!equals(this.p9c_1, tmp0_other_with_cast.p9c_1))
      return false;
    if (!(this.q9c_1 === tmp0_other_with_cast.q9c_1))
      return false;
    if (!equals(this.r9c_1, tmp0_other_with_cast.r9c_1))
      return false;
    if (!(this.s9c_1 === tmp0_other_with_cast.s9c_1))
      return false;
    if (!equals(this.t9c_1, tmp0_other_with_cast.t9c_1))
      return false;
    if (!equals(this.u9c_1, tmp0_other_with_cast.u9c_1))
      return false;
    if (!(this.v9c_1 == tmp0_other_with_cast.v9c_1))
      return false;
    if (!(this.w9c_1 == tmp0_other_with_cast.w9c_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.t9f_1 = new KorgeDisplayMode(Companion_getInstance_24().n2g_1, Companion_getInstance_25().p25(), true);
    this.u9f_1 = new KorgeDisplayMode(Companion_getInstance_24().n2g_1, Companion_getInstance_25().p25(), false);
    this.v9f_1 = new KorgeDisplayMode(Companion_getInstance_24().n2g_1, Companion_getInstance_25().d25_1, false);
    this.w9f_1 = new KorgeDisplayMode(Companion_getInstance_24().p2g_1, Companion_getInstance_25().d25_1, false);
  }
  j3o() {
    return this.t9f_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_37();
    this.z9f_1 = scaleMode;
    this.a9g_1 = scaleAnchor;
    this.b9g_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.z9f_1.toString() + ', scaleAnchor=' + this.a9g_1.toString() + ', clipBorders=' + this.b9g_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.z9f_1);
    result = imul(result, 31) + this.a9g_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b9g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.z9f_1, tmp0_other_with_cast.z9f_1))
      return false;
    if (!this.a9g_1.equals(tmp0_other_with_cast.a9g_1))
      return false;
    if (!(this.b9g_1 === tmp0_other_with_cast.b9g_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.q9i_1 = $config;
    this.r9i_1 = $views;
    this.s9i_1 = $entry;
    this.t9i_1 = $gameWindow;
  }
  h1b($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.w9n_1 = $config;
    this.x9n_1 = $views;
    this.y9n_1 = $entry;
    this.z9n_1 = $gameWindow;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.a9o_1 = $realGameWindow;
    this.b9o_1 = $windowSize;
    this.c9o_1 = $config;
    this.d9o_1 = $iconPath;
    this.e9o_1 = $imageFormats;
    this.f9o_1 = $entry;
  }
  n9o($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  pd(p1, $completion) {
    return this.n9o(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.o9o_1 = $views;
  }
  od($completion) {
    this.o9o_1.y5();
  }
}
class KorgeRunner {
  z9c(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  j9o(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.j9g_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.d62(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.i9g_1;
    injector.d62(getKClass(AG), instance);
    injector.d62(getKClass(Resources), views.q9o());
    var tmp = getKClass(ResourcesRoot);
    injector.g62(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.k9g_1;
    injector.d62(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.m9g_1;
    injector.d62(getKClass(Stats), instance_1);
    injector.d62(getKClass(CoroutineContext), views.h9g_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.h62(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.d62(getKClass(TimeProvider), views.l9g_1);
    configInjector(injector);
    var input = views.k9g_1;
    var ag = views.i9g_1;
    var downPos = {_v: Companion_getInstance_27().e26_1};
    var upPos = {_v: Companion_getInstance_27().e26_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().j1v_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().j1v_1)};
    var upTime = Companion_getInstance_5().j1v_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.r9o(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().z66_1.slice();
    eventDispatcher.k65(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().l66_1.slice();
    eventDispatcher.k65(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().a68_1.slice();
    eventDispatcher.k65(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().h68_1.slice();
    eventDispatcher.k65(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.y64(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.y64(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.y64(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.y64(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().c69_1.slice();
    eventDispatcher.k65(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().h6b_1.slice();
    eventDispatcher.k65(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.y64(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.y64(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.j65(new ReshapeEvent(0, 0, views.s9o(), views.t9o()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.y64(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.h9h_1 = clearEachFrame;
    views.i9h_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.n9g_1.a8g(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  c9d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.c9d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  c9d(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  pd(p1, $completion) {
    return this.c9d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.a9p_1 = this$0;
    this.b9p_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.c9p_1 = this$0;
    this.d9p_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.e9p_1 = this$0;
    this.f9p_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.u9o_1 = view;
    this.w9o_1 = new AsyncSignal();
    this.x9o_1 = new AsyncSignal();
    this.y9o_1 = new AsyncSignal();
    this.z9o_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.u9o_1.y64(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.u9o_1.y64(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.u9o_1.y64(tmp_1, KeysEvents$lambda_1(this));
  }
  g9p() {
    var tmp = this.v9o_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  y5() {
    this.z9o_1.y5();
  }
}
class MouseDragInfo {
  constructor(view, dx, dy, start, end, startTime, time, sx, sy, cx, cy) {
    dx = dx === VOID ? 0.0 : dx;
    dy = dy === VOID ? 0.0 : dy;
    start = start === VOID ? false : start;
    end = end === VOID ? false : end;
    startTime = startTime === VOID ? Companion_getInstance_5().j1v_1 : startTime;
    time = time === VOID ? Companion_getInstance_5().j1v_1 : time;
    sx = sx === VOID ? 0.0 : sx;
    sy = sy === VOID ? 0.0 : sy;
    cx = cx === VOID ? 0.0 : cx;
    cy = cy === VOID ? 0.0 : cy;
    this.h9p_1 = view;
    this.i9p_1 = dx;
    this.j9p_1 = dy;
    this.k9p_1 = start;
    this.l9p_1 = end;
    this.m9p_1 = startTime;
    this.n9p_1 = time;
    this.o9p_1 = sx;
    this.p9p_1 = sy;
    this.q9p_1 = cx;
    this.r9p_1 = cy;
    this.t9p_1 = NaN;
    this.u9p_1 = NaN;
    this.v9p_1 = 0.0;
    this.w9p_1 = 0.0;
  }
  toString() {
    return 'MouseDragInfo(start=' + this.k9p_1 + ', end=' + this.l9p_1 + ', sx=' + this.o9p_1 + ', sy=' + this.p9p_1 + ', cx=' + this.q9p_1 + ', cy=' + this.r9p_1 + ')';
  }
  x9p(view) {
    var tmp0_safe_receiver = view.n24();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9p(Vector2D.l28(0.0, 0.0), Vector2D.l28(this.i9p_1, this.j9p_1));
    return tmp1_elvis_lhs == null ? Vector2D.l28(this.i9p_1, this.j9p_1) : tmp1_elvis_lhs;
  }
  z9p(view) {
    return this.x9p(view).c26_1;
  }
  a9q(view) {
    return this.x9p(view).d26_1;
  }
  d2q() {
    this.t9p_1 = NaN;
    this.u9p_1 = NaN;
    this.v9p_1 = 0.0;
    this.w9p_1 = 0.0;
    this.i9p_1 = 0.0;
    this.j9p_1 = 0.0;
    this.o9p_1 = 0.0;
    this.p9p_1 = 0.0;
    this.q9p_1 = 0.0;
    this.r9p_1 = 0.0;
  }
  b9q(dx, dy, start, end, time, sx, sy, cx, cy) {
    this.i9p_1 = dx;
    this.j9p_1 = dy;
    this.o9p_1 = sx;
    this.p9p_1 = sy;
    this.q9p_1 = cx;
    this.r9p_1 = cy;
    if (!isNaN_0(this.t9p_1) && !isNaN_0(this.u9p_1)) {
      this.v9p_1 = this.t9p_1 - dx;
      this.w9p_1 = this.u9p_1 - dy;
    }
    this.t9p_1 = dx;
    this.u9p_1 = dy;
    this.k9p_1 = start;
    this.l9p_1 = end;
    if (start)
      this.m9p_1 = time;
    this.n9p_1 = time;
    return this;
  }
}
class OnMouseDragCloseable {
  constructor(onDownCloseable, onUpAnywhereCloseable, onMoveAnywhereCloseable) {
    this.c9q_1 = onDownCloseable;
    this.d9q_1 = onUpAnywhereCloseable;
    this.e9q_1 = onMoveAnywhereCloseable;
  }
  y5() {
    this.c9q_1.y5();
    this.d9q_1.y5();
    this.e9q_1.y5();
  }
  toString() {
    return 'OnMouseDragCloseable(onDownCloseable=' + toString(this.c9q_1) + ', onUpAnywhereCloseable=' + toString(this.d9q_1) + ', onMoveAnywhereCloseable=' + toString(this.e9q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.c9q_1);
    result = imul(result, 31) + hashCode(this.d9q_1) | 0;
    result = imul(result, 31) + hashCode(this.e9q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnMouseDragCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof OnMouseDragCloseable ? other : THROW_CCE();
    if (!equals(this.c9q_1, tmp0_other_with_cast.c9q_1))
      return false;
    if (!equals(this.d9q_1, tmp0_other_with_cast.d9q_1))
      return false;
    if (!equals(this.e9q_1, tmp0_other_with_cast.e9q_1))
      return false;
    return true;
  }
}
class MouseDragState extends Enum {
  a6a() {
    return this.equals(MouseDragState_START_getInstance());
  }
  b6a() {
    return this.equals(MouseDragState_END_getInstance());
  }
}
class DraggableCloseable {
  constructor(onMouseDragCloseable) {
    this.h9q_1 = onMouseDragCloseable;
  }
  y5() {
    this.h9q_1.y5();
  }
  toString() {
    return 'DraggableCloseable(onMouseDragCloseable=' + toString(this.h9q_1) + ')';
  }
  hashCode() {
    return hashCode(this.h9q_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DraggableCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof DraggableCloseable ? other : THROW_CCE();
    if (!equals(this.h9q_1, tmp0_other_with_cast.h9q_1))
      return false;
    return true;
  }
}
class DraggableInfo extends MouseDragInfo {
  constructor(view) {
    super(view);
    this.y9q_1 = Vector2D.w28();
    this.z9q_1 = Vector2D.w28();
    this.a9r_1 = Vector2D.w28();
    this.b9r_1 = Companion_getInstance_27().e26_1;
  }
  c9r() {
    return this.y9q_1.c26_1;
  }
  d9r() {
    return this.y9q_1.d26_1;
  }
  e9r() {
    return this.z9q_1.c26_1;
  }
  f9r() {
    return this.z9q_1.d26_1;
  }
  g9r() {
    return this.a9r_1.c26_1;
  }
  h9r() {
    return this.a9r_1.d26_1;
  }
}
class onMouseDragInternal$slambda {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.l9r_1 = $dragging;
    this.m9r_1 = $info;
    this.n9r_1 = $mousePos;
    this.o9r_1 = $sx;
    this.p9r_1 = $sy;
    this.q9r_1 = $cx;
    this.r9r_1 = $cy;
    this.s9r_1 = $callback;
    this.t9r_1 = $timeProvider;
    this.u9r_1 = $view;
  }
  v9r(it, $completion) {
    onMouseDragInternal$handle(this.l9r_1, this.m9r_1, this.n9r_1, this.o9r_1, this.p9r_1, this.q9r_1, this.r9r_1, this.s9r_1, this.t9r_1, this.u9r_1, it, MouseDragState_START_getInstance());
  }
  pd(p1, $completion) {
    return this.v9r(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda {
  constructor($handler, $it) {
    this.w9r_1 = $handler;
    this.x9r_1 = $it;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_0 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.o9t_1 = $dragging;
    this.p9t_1 = $info;
    this.q9t_1 = $mousePos;
    this.r9t_1 = $sx;
    this.s9t_1 = $sy;
    this.t9t_1 = $cx;
    this.u9t_1 = $cy;
    this.v9t_1 = $callback;
    this.w9t_1 = $timeProvider;
    this.x9t_1 = $view;
  }
  v9r(it, $completion) {
    onMouseDragInternal$handle(this.o9t_1, this.p9t_1, this.q9t_1, this.r9t_1, this.s9t_1, this.t9t_1, this.u9t_1, this.v9t_1, this.w9t_1, this.x9t_1, it, MouseDragState_END_getInstance());
  }
  pd(p1, $completion) {
    return this.v9r(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_0 {
  constructor($handler, $it) {
    this.y9t_1 = $handler;
    this.z9t_1 = $it;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class onMouseDragInternal$slambda_1 {
  constructor($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
    this.a9u_1 = $dragging;
    this.b9u_1 = $info;
    this.c9u_1 = $mousePos;
    this.d9u_1 = $sx;
    this.e9u_1 = $sy;
    this.f9u_1 = $cx;
    this.g9u_1 = $cy;
    this.h9u_1 = $callback;
    this.i9u_1 = $timeProvider;
    this.j9u_1 = $view;
  }
  v9r(it, $completion) {
    onMouseDragInternal$handle(this.a9u_1, this.b9u_1, this.c9u_1, this.d9u_1, this.e9u_1, this.f9u_1, this.g9u_1, this.h9u_1, this.i9u_1, this.j9u_1, it, MouseDragState_DRAG_getInstance());
  }
  pd(p1, $completion) {
    return this.v9r(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class onMouseDragInternal$lambda$slambda_1 {
  constructor($handler, $it) {
    this.k9u_1 = $handler;
    this.l9u_1 = $it;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class Companion_1 {
  s9u(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.z34_1) {
      this_0.z34_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.z9h_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.v9u_1 = $outer;
    this.t9u_1 = new Mixin();
    this.u9u_1 = view;
    addUpdaterWithViews(this.u9u_1, MouseEvents$MouseEventsUpdate$lambda(this.v9u_1));
  }
  y1i(value) {
    this.t9u_1.y1i(value);
  }
  z1i() {
    return this.t9u_1.z1i();
  }
}
class MouseEvents {
  constructor(view) {
    this.y9r_1 = new Mixin();
    this.z9r_1 = view;
    this.z9r_1.y9u(true);
    this.b9s_1 = new Signal();
    this.c9s_1 = new Signal();
    this.d9s_1 = new Signal();
    this.e9s_1 = new Signal();
    this.f9s_1 = new Signal();
    this.g9s_1 = new Signal();
    this.h9s_1 = new Signal();
    this.i9s_1 = new Signal();
    this.j9s_1 = new Signal();
    this.k9s_1 = new Signal();
    this.l9s_1 = new Signal();
    this.m9s_1 = new Signal();
    this.n9s_1 = new Signal();
    this.o9s_1 = new Signal();
    this.p9s_1 = new Signal();
    this.q9s_1 = new Signal();
    this.r9s_1 = new Signal();
    this.s9s_1 = new Signal();
    this.t9s_1 = new Signal();
    this.u9s_1 = null;
    this.v9s_1 = false;
    this.w9s_1 = false;
    this.x9s_1 = false;
    this.y9s_1 = PerformanceCounter_getInstance().y62();
    this.z9s_1 = PerformanceCounter_getInstance().y62();
    this.a9t_1 = Vector2D.w28();
    this.b9t_1 = Vector2D.w28();
    this.c9t_1 = Vector2D.w28();
    this.d9t_1 = Vector2D.w28();
    this.e9t_1 = Vector2D.w28();
    this.f9t_1 = 0;
    this.g9t_1 = false;
    this.h9t_1 = null;
    this.i9t_1 = new MouseEvent();
    this.j9t_1 = false;
    this.k9t_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().z66_1.slice();
    tmp.l9t_1 = this.z9r_1.k65(tmp_0, MouseEvents$closeable$lambda(this));
    this.m9t_1 = new MouseEventsUpdate(this, this.z9r_1);
  }
  j9r() {
    var tmp = this.a9s_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  n9t() {
    return this.j9r().h9g_1;
  }
  z9u() {
    return this.j9r().t9h_1.a9v(this.a9t_1);
  }
  x9u() {
    var tmp0_safe_receiver = this.u9s_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.z9r_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  b9v() {
    return !(this.j9r().k9g_1.y80_1 === 0);
  }
  toString() {
    return this.i9t_1.toString();
  }
  r9u(views, dt) {
    if (!this.z9r_1.w9u())
      return Unit_instance;
    this.a9s_1 = views;
    Companion_instance_16.s9u(views);
    this.u9s_1 = mouseHitTest(Companion_instance_16, views);
    var over = this.x9u();
    var inside = views.k9g_1.a81_1;
    if (over) {
      set_mouseHitResultUsed(views.k9g_1, this.z9r_1);
    }
    var overChanged = !(this.v9s_1 === over);
    var insideChanged = !(this.w9s_1 === inside);
    var pressingChanged = !(this.b9v() === this.x9s_1);
    this.e9t_1 = views.k9g_1.o81();
    if (!overChanged && over && !this.e9t_1.equals(this.d9t_1)) {
      this.n9s_1.z1w(this);
    }
    if (!overChanged && !over && !this.e9t_1.equals(this.d9t_1)) {
      this.p9s_1.z1w(this);
    }
    if (!this.e9t_1.equals(this.d9t_1)) {
      this.o9s_1.z1w(this);
    }
    if (overChanged && over) {
      this.d9s_1.z1w(this);
    }
    if (overChanged && !over) {
      this.e9s_1.z1w(this);
    }
    if (pressingChanged && this.b9v()) {
      this.c9t_1 = this.e9t_1;
      if (over) {
        this.f9s_1.z1w(this);
      }
      if (!over) {
        this.g9s_1.z1w(this);
      }
    }
    if (overChanged && this.b9v()) {
      this.h9s_1.z1w(this);
    }
    if (pressingChanged && !this.b9v()) {
      var tmp = this.k9t_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.f9t_1 > 0;
    if (insideChanged && !inside) {
      this.p9s_1.z1w(this);
      this.e9s_1.z1w(this);
      this.k9s_1.z1w(this);
      this.l9s_1.z1w(this);
      this.q9s_1.z1w(this);
    }
    this.v9s_1 = over;
    this.w9s_1 = inside;
    this.x9s_1 = this.b9v();
    this.d9t_1 = this.e9t_1;
    this.f9t_1 = 0;
  }
  y5() {
    this.l9t_1.y5();
  }
  y1i(value) {
    this.y9r_1.y1i(value);
  }
  z1i() {
    return this.y9r_1.z1i();
  }
}
class SceneCancellationException extends CancellationException {
  static i9v(scene) {
    var $this = this.gd('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.h9v_1);
    $this.g9v_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.j9v_1 = new Mixin();
    this.o9v_1 = Container.g9y();
    this.p9v_1 = new CancellableGroup();
    var tmp = this;
    tmp.q9v_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r9v_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s9v_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  u9v() {
    var tmp = this.k9v_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  h9y(_set____db54di) {
    this.l9v_1 = _set____db54di;
  }
  j9r() {
    var tmp = this.l9v_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  v9v() {
    var tmp = this.m9v_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  ds() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q9v_1;
    coroutineContext$factory();
    return this_0.o1();
  }
  i9y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r9v_1;
    sceneView$factory();
    return this_0.o1();
  }
  w9v(size) {
    return SContainer.ua0(size);
  }
  o62(injector) {
    this.k9v_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.m62(getKClass(Views));
    this.h9y(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.m9v_1 = injector.m62(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.n9v_1 = injector.m62(getKClass(ResourcesRoot));
  }
  va0(_this__u8e3s4, $completion) {
  }
  wa0(_this__u8e3s4, $completion) {
  }
  xa0($completion) {
  }
  ya0($completion) {
  }
  za0($completion) {
  }
  aa1() {
    cancel_0(this.p9v_1);
    this.u9v().p62();
  }
  t9v($completion) {
  }
  ba1($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  ca1(size_0) {
    size(this.i9y(), size_0);
  }
  y1i(value) {
    this.j9v_1.y1i(value);
  }
  z1i() {
    return this.j9v_1.z1i();
  }
}
class EmptyScene extends Scene {
  wa0(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.ta4_1 = clazz;
    this.ua4_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.ta4_1) + ', injects=' + toString(this.ua4_1) + ')';
  }
  hashCode() {
    var result = this.ta4_1.hashCode();
    result = imul(result, 31) + hashCode(this.ua4_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.ta4_1.equals(tmp0_other_with_cast.ta4_1))
      return false;
    if (!equals(this.ua4_1, tmp0_other_with_cast.ua4_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.xa1_1 = Companion_getInstance_0().c1h('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.ya1_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.na1_1 = this$0;
    this.oa1_1 = $event;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.aa2_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.ba2_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.ca2_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.da2_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.ea2_1 = $oldScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.fa2_1 = $newScene;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static xar($box) {
    return this.w64($box);
  }
  qaa() {
  }
}
class View extends BaseView {
  static rb0(isContainer, $box) {
    var $this = this.xar($box);
    $this.y9i_1 = isContainer;
    var tmp = $this;
    tmp.z9i_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.a9j_1 = true;
    $this.b9j_1 = null;
    $this.c9j_1 = null;
    $this.d9j_1 = null;
    $this.e9j_1 = 0;
    $this.f9j_1 = null;
    $this.g9j_1 = 1.0;
    $this.h9j_1 = null;
    $this.i9j_1 = null;
    $this.j9j_1 = null;
    $this.k9j_1 = Companion_getInstance_13().p7w_1;
    $this.l9j_1 = 0.0;
    $this.m9j_1 = 0.0;
    $this.n9j_1 = 1.0;
    $this.o9j_1 = 1.0;
    $this.p9j_1 = Companion_getInstance_31().t25_1;
    $this.q9j_1 = Companion_getInstance_31().t25_1;
    $this.r9j_1 = Companion_getInstance_31().t25_1;
    $this.s9j_1 = 0.0;
    $this.t9j_1 = scale$factory($this);
    $this.u9j_1 = false;
    $this.v9j_1 = true;
    $this.w9j_1 = true;
    $this.x9j_1 = true;
    $this.y9j_1 = true;
    $this.z9j_1 = Companion_getInstance_30().n29_1;
    $this.a9k_1 = Companion_getInstance_30().n29_1;
    $this.b9k_1 = -1;
    $this.c9k_1 = Companion_getInstance_30().n29_1;
    $this.d9k_1 = -1;
    $this.e9k_1 = new ColorTransformMul();
    $this.f9k_1 = new ColorTransformMul();
    $this.g9k_1 = -1;
    $this.h9k_1 = Companion_getInstance_13().p7w_1;
    $this.i9k_1 = -1;
    $this.j9k_1 = true;
    $this.k9k_1 = 0;
    $this.l9k_1 = 0;
    $this.m9k_1 = false;
    $this.n9k_1 = false;
    $this.o9k_1 = null;
    $this.p9k_1 = false;
    $this.q9k_1 = null;
    $this.r9k_1 = 0;
    $this.s9k_1 = true;
    $this.t9k_1 = null;
    return $this;
  }
  oab() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z9i_1;
    bviewAll$factory();
    return this_0.o1();
  }
  static lb6($box) {
    return this.rb0(false, $box);
  }
  pab() {
    return 0.0;
  }
  qab() {
    return 0.0;
  }
  taa() {
    return null;
  }
  war(_set____db54di) {
    this.c9j_1 = _set____db54di;
  }
  rab() {
    return this.c9j_1;
  }
  sab() {
    return this.d9j_1;
  }
  wax(value) {
    this.b9j_1 = value;
  }
  tab(value) {
    this.e9j_1 = value;
  }
  s6b() {
    return this.e9j_1;
  }
  uab(value) {
    if (this.h9j_1 === value)
      return Unit_instance;
    this.h9j_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.taa();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.f1(_unary__edvuaz).uab(value);
      }
      tmp = Unit_instance;
    }
    this.vab();
  }
  vab() {
  }
  wab(value) {
    if (this.i9j_1 === value)
      return Unit_instance;
    this.i9j_1 = value;
    var parent = this.raa();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.taa();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.f1(_unary__edvuaz).wab(parent);
      }
      tmp = Unit_instance;
    }
  }
  raa() {
    return this.i9j_1;
  }
  xab() {
    var tmp0_safe_receiver = this.f9j_1;
    this.wab(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.raa());
  }
  yab(value) {
    if (this.f9j_1 === value)
      return Unit_instance;
    this.f9j_1 = value;
    var tmp0_safe_receiver = this.f9j_1;
    this.uab(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h9j_1);
    this.xab();
    this.mad();
    this.x64(value);
  }
  n24() {
    return this.f9j_1;
  }
  zab() {
    return !(this.n24() == null) ? ensureNotNull(this.n24()).zab() * this.g9j_1 : this.g9j_1;
  }
  aac(x, y) {
    this.cad();
    if (!(this.l9j_1 === x) || !(this.m9j_1 === y)) {
      this.l9j_1 = x;
      this.m9j_1 = y;
      this.kad();
    }
  }
  d4q(value) {
    return this.aac(value.c26_1, value.d26_1);
  }
  t1h() {
    return Vector2D.l28(this.z68(), this.a69());
  }
  bac(v) {
    this.aac(v, this.a69());
  }
  z68() {
    this.cad();
    return this.l9j_1;
  }
  cac(v) {
    this.aac(this.z68(), v);
  }
  a69() {
    this.cad();
    return this.m9j_1;
  }
  dac(v) {
    var tmp0_safe_receiver = this.n24();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jab(this, this.s9j_1, v);
    }
    this.s9j_1 = v;
  }
  eac() {
    return this.s9j_1;
  }
  fac(v) {
    this.lac(Scale.z2d(v, v));
  }
  gac() {
    return this.mac().b2c();
  }
  hac(v) {
    this.cad();
    if (!(this.n9j_1 === v)) {
      this.n9j_1 = v;
      this.kad();
    }
  }
  iac() {
    this.cad();
    return this.n9j_1;
  }
  jac(v) {
    this.cad();
    if (!(this.o9j_1 === v)) {
      this.o9j_1 = v;
      this.kad();
    }
  }
  kac() {
    this.cad();
    return this.o9j_1;
  }
  lac(value) {
    this.hac(value.x2d_1);
    this.jac(value.y2d_1);
  }
  mac() {
    return Scale.z2d(this.iac(), this.kac());
  }
  nac() {
    this.cad();
    return this.p9j_1;
  }
  oac() {
    this.cad();
    return this.q9j_1;
  }
  rbf(v) {
    this.cad();
    if (!equals(this.r9j_1, v)) {
      this.r9j_1 = v;
      this.kad();
    }
  }
  pac() {
    this.cad();
    return this.r9j_1;
  }
  qac() {
    var tmp0_safe_receiver = this.n24();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sad(Vector2D.l28(this.z68(), this.a69()));
    return tmp1_elvis_lhs == null ? Vector2D.l28(this.z68(), this.a69()) : tmp1_elvis_lhs;
  }
  rac(value) {
    this.ua7(value);
  }
  d1() {
    return this.va7();
  }
  ua7(value) {
    var size = this.d1();
    this.lac(Scale.z2d((this.iac() === 0.0 ? 1.0 : this.iac()) * (value.h27_1 / size.h27_1), (this.kac() === 0.0 ? 1.0 : this.kac()) * (value.i27_1 / size.i27_1)));
  }
  va7() {
    return this.n9u().d1();
  }
  sac(value) {
    this.ua7(this.va7().a2h(value));
  }
  tac() {
    return this.va7().h27_1;
  }
  uac(value) {
    this.ua7(this.va7().a2h(VOID, value));
  }
  vac() {
    return this.va7().i27_1;
  }
  wac() {
    return this.tac() * this.iac();
  }
  xac() {
    return this.vac() * this.kac();
  }
  yac(value) {
    this.sac(value);
  }
  w2i() {
    return this.tac();
  }
  zac(value) {
    this.uac(value);
  }
  x2i() {
    return this.vac();
  }
  y4c(v) {
    if (!(v === this.e9k_1.a4d())) {
      this.e9k_1.y4c(v);
      this.vaa();
    }
  }
  a4d() {
    return this.e9k_1.a4d();
  }
  aad(v) {
    if (!(this.e9k_1.x4c() === v)) {
      this.e9k_1.w4c(v);
      this.vaa();
    }
  }
  bad() {
    return this.e9k_1.x4c();
  }
  cad() {
    if (this.x9j_1)
      return Unit_instance;
    this.x9j_1 = true;
    var t = this.z9j_1.d2b();
    this.l9j_1 = t.p2b_1;
    this.m9j_1 = t.q2b_1;
    this.n9j_1 = t.r2b_1;
    this.o9j_1 = t.s2b_1;
    this.p9j_1 = t.t2b_1;
    this.q9j_1 = t.u2b_1;
    this.r9j_1 = t.v2b_1;
  }
  h24() {
    var tmp0_safe_receiver = this.n24();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h24();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  i9r() {
    return this.h9j_1;
  }
  y9u(_set____db54di) {
    this.u9j_1 = _set____db54di;
  }
  w9u() {
    return this.u9j_1;
  }
  dad() {
    return this.v9j_1;
  }
  h8g(value) {
    if (!(this.w9j_1 === value)) {
      this.w9j_1 = value;
      this.uaa();
    }
  }
  ead() {
    return this.w9j_1;
  }
  fad() {
    if (!this.y9j_1) {
      this.y9j_1 = true;
      this.m9k_1 = true;
      this.z9j_1 = Companion_getInstance_30().b2a(this.z68(), this.a69(), this.pac(), this.iac(), this.kac(), this.nac(), this.oac(), 0.0, 0.0);
    }
    return this.z9j_1;
  }
  p9u() {
    if (!(this.b9k_1 === this.k9k_1)) {
      this.b9k_1 = this.k9k_1;
      this.m9k_1 = true;
      this.a9k_1 = !(this.n24() == null) ? this.fad().e2a(ensureNotNull(this.n24()).p9u()) : this.fad();
    }
    return this.a9k_1;
  }
  gad() {
    if (!(this.d9k_1 === this.k9k_1)) {
      this.d9k_1 = this.k9k_1;
      this.m9k_1 = true;
      this.c9k_1 = this.p9u().c2b();
    }
    return this.c9k_1;
  }
  had() {
    updateRenderColorTransformIfRequired(this);
    return this.f9k_1;
  }
  iad() {
    updateRenderBlendModeIfRequired(this);
    return this.h9k_1;
  }
  jad() {
    updateRenderColorTransformIfRequired(this);
    return this.f9k_1.a4d();
  }
  ub0(views) {
    return this.a9v(views.k9g_1.o81());
  }
  kad() {
    this.y9j_1 = false;
    this.uaa();
  }
  uaa() {
    this.k9k_1 = this.k9k_1 + 1 | 0;
    this.m9k_1 = false;
    this.j9k_1 = true;
    this.qaa();
  }
  lad() {
    if (!(this.o9k_1 == null)) {
      this.o9k_1 = null;
      var tmp0_safe_receiver = this.n24();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.lad();
      }
    }
  }
  mad() {
    this.ya7();
  }
  nad() {
    this.ya7();
  }
  ya7() {
  }
  qaa() {
    var tmp0_safe_receiver = this.i9j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.saa(this);
    }
    this.lad();
  }
  vaa() {
    this.l9k_1 = this.l9k_1 + 1 | 0;
    this.n9k_1 = false;
    this.j9k_1 = true;
    this.qaa();
  }
  wa7(ctx) {
    if (!this.ead())
      return Unit_instance;
    var tmp0_safe_receiver = this.q9k_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.p1j_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].lbp(this, ctx);
      }
    }
    try {
      this.oad(ctx);
    }finally {
      var tmp1_safe_receiver = this.q9k_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.p1j_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.d1() - n_0 | 0) - 1 | 0].mbp(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  oad(ctx) {
    var oldPhase = this.r9k_1;
    try {
      this.r9k_1 = 0;
      this.pad(ctx);
    }finally {
      this.r9k_1 = oldPhase;
    }
  }
  pad(ctx) {
    var stages = this.q9k_1;
    if (!(stages == null) && this.r9k_1 < stages.d1()) {
      var _unary__edvuaz = this.r9k_1;
      this.r9k_1 = _unary__edvuaz + 1 | 0;
      stages.f1(_unary__edvuaz).nbp(this, ctx);
    } else {
      var tmp = this.r9k_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.d1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.aa8(ctx);
        this.r9k_1 = this.r9k_1 + 1 | 0;
      }
    }
  }
  fab(ctx) {
    if (this.p9k_1 || this === get_debugAnnotateView(ctx)) {
      this.qad(ctx);
    }
  }
  qad(ctx) {
    var local = this.n9u();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.j87_1;
    if (!(this_1.l7y_1 === this_0)) {
      this_1.l7y_1 = this_0;
      this_1.v7z();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.v87_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().y7w_1;
          var doUpdate = !(this_0.u87_1 === blending);
          var old = this_0.u87_1;
          try {
            if (doUpdate) {
              this_0.j87_1.v7z();
              this_0.u87_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().o3x_1;
            var m = this_0.v87_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.m87_1;
            this_0.m87_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.p3n(this.dae());
              this_0.b88(this_3, m);
            }finally {
              this_0.m87_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.j87_1.v7z();
            }
            this_0.u87_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().o3x_1;
        var m_0 = this_0.v87_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.m87_1;
        this_0.m87_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.b3e(this.sad(Vector2D.l28(local.t26(), local.v26())));
          this_4.d3e(this.sad(Vector2D.l28(local.u26(), local.v26())));
          this_4.d3e(this.sad(Vector2D.l28(local.u26(), local.w26())));
          this_4.d3e(this.sad(Vector2D.l28(local.t26(), local.w26())));
          this_4.y5();
          this_0.b88(this_4, m_0);
        }finally {
          this_0.m87_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().c43_1;
        var m_1 = this_0.v87_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.m87_1;
        this_0.m87_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).c87();
          this_5.j38(this.sad(local.l27()), anchorSize);
          this_5.j38(this.sad(local.x2e()), anchorSize);
          this_5.j38(this.sad(local.n27()), anchorSize);
          this_5.j38(this.sad(local.y2e()), anchorSize);
          this_5.j38(this.sad(interpolate(Companion_getInstance_34().o1i_1, local.l27(), local.x2e())), anchorSize);
          this_5.j38(this.sad(interpolate(Companion_getInstance_34().o1i_1, local.x2e(), local.n27())), anchorSize);
          this_5.j38(this.sad(interpolate(Companion_getInstance_34().o1i_1, local.n27(), local.y2e())), anchorSize);
          this_5.j38(this.sad(interpolate(Companion_getInstance_34().o1i_1, local.y2e(), local.l27())), anchorSize);
          this_0.b88(this_5, m_1);
        }finally {
          this_0.m87_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().q3x_1;
        var m_2 = this_0.v87_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.m87_1;
        this_0.m87_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.qac();
          this_6.n3n(Vector2D.l28(center.c26_1, center.d26_1 - 5), Vector2D.l28(center.c26_1, center.d26_1 + 5));
          this_6.n3n(Vector2D.l28(center.c26_1 - 5, center.d26_1), Vector2D.l28(center.c26_1 + 5, center.d26_1));
          this_0.b88(this_6, m_2);
        }finally {
          this_0.m87_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.z68() === 0.0) || !(this.a69() === 0.0))
      out = out + (':pos=(' + this.rad(this.z68()) + ',' + this.rad(this.a69()) + ')');
    if (!(this.iac() === 1.0) || !(this.kac() === 1.0))
      out = out + (':scale=(' + this.rad(this.iac()) + ',' + this.rad(this.kac()) + ')');
    if (!equals(this.nac(), Companion_getInstance_31().t25_1) || !equals(this.oac(), Companion_getInstance_31().t25_1))
      out = out + (':skew=(' + this.rad(_Angle___get_degrees__impl__qg56vw(this.nac())) + ',' + this.rad(_Angle___get_degrees__impl__qg56vw(this.oac())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.pac()), Companion_getInstance_31().t25_1))
      out = out + (':rotation=(' + this.rad(_Angle___get_degrees__impl__qg56vw(this.pac())) + '\xBA)');
    if (!(this.j9j_1 == null))
      out = out + (':name=(' + this.j9j_1 + ')');
    if (!this.k9j_1.equals(Companion_getInstance_13().p7w_1))
      out = out + (':blendMode=(' + this.k9j_1.toString() + ')');
    if (!this.ead())
      out = out + (':visible=' + this.ead());
    if (!(this.bad() === 1.0))
      out = out + (':alpha=' + niceStr(this.bad(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.a4d()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().m3x_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.a4d()));
    return out;
  }
  rad(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  a9v(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.gad();
      if (this_0.r26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
    }
    return tmp$ret$0;
  }
  y9p(p0, p1) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.a9v(p1);
    var that = this.a9v(p0);
    return Vector2D.l28(this_0.c26_1 - that.c26_1, this_0.d26_1 - that.d26_1);
  }
  sad(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.p9u();
      if (this_0.r26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
    }
    return tmp$ret$0;
  }
  m9u(p) {
    if (!this.s9k_1)
      return null;
    if (!this.ead())
      return null;
    if (this.dad()) {
      var tmp0_safe_receiver = this.taa();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.d1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.f1((tmp0_safe_receiver.d1() - n | 0) - 1 | 0).m9u(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.w9u())
      return null;
    var tmp1_safe_receiver = this.vad(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.tad();
      if (!area.r26() && !area.i28(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  tad() {
    var out = Companion_getInstance_28().z26_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n24();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.c5r();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.fae();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.f2f(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.n24();
    }
    return count === 0 ? Companion_getInstance_28().b27() : out;
  }
  uad(p, direction) {
    if (!this.s9k_1)
      return null;
    var ll = this.a9v(p);
    var bounds = this.n9u();
    if (!bounds.i28(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.y2a(this.pab(), this.qab());
    var l = Vector2D.l28(ll.c26_1 + that.c26_1, ll.d26_1 + that.d26_1);
    if (this.t9k_1 === false)
      return this;
    var hitShape = this.rab();
    var hitShapes = this.sab();
    if (this.t9k_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.d1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.f1(_unary__edvuaz).m3o(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.m3o(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  vad(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.uad(p, direction) : $super.uad.call(this, p, direction);
  }
  wad() {
    var tmp0_safe_receiver = this.n24();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.nab(this);
  }
  xad(target, inclusive) {
    var tmp;
    if (target === this.n24()) {
      tmp = this.fad();
    } else if (target === this) {
      tmp = Companion_getInstance_30().n29_1;
    } else {
      var commonAncestor = Companion_instance_23.kbp(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.n24() == null && inclusive) {
          return this.p9u();
        }
        tmp_0 = this.p9u().e2a(target.gad());
      } else {
        tmp_0 = Companion_getInstance_30().n29_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.e2a(target.fad());
    }
    return out;
  }
  yad() {
    var tmp0_elvis_lhs = this.zad();
    return tmp0_elvis_lhs == null ? this.fae() : tmp0_elvis_lhs;
  }
  zad() {
    var stage = this.h24();
    if (!(stage instanceof Stage))
      return null;
    return this.aae(stage);
  }
  aae(bp) {
    return this.fae().n2f(bp.y86());
  }
  bae(ctx) {
    return ctx.j88() ? this.aae(ctx) : this.fae();
  }
  cae(ctx) {
    return this.bae(ctx);
  }
  dae() {
    return this.fae();
  }
  eae(includeFilters) {
    return this.kae(this.h24(), VOID, true, includeFilters);
  }
  fae(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.eae(includeFilters) : $super.eae.call(this, includeFilters);
  }
  gae(target, inclusive, includeFilters) {
    return this.jae(target, false, inclusive, includeFilters);
  }
  hae(target, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.gae(target, inclusive, includeFilters) : $super.gae.call(this, target, inclusive, includeFilters);
  }
  iae(concat, doAnchoring, includeFilters) {
    var out = this.lae(doAnchoring, includeFilters);
    if (concat.s26() && !concat.f2a()) {
      var tmp = Companion_getInstance_29();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.l27();
        if (concat.r26()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.l28(concat.i2a(p.c26_1, p.d26_1), concat.l2a(p.c26_1, p.d26_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.x2e();
        if (concat.r26()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.l28(concat.i2a(p_0.c26_1, p_0.d26_1), concat.l2a(p_0.c26_1, p_0.d26_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.n27();
        if (concat.r26()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.l28(concat.i2a(p_1.c26_1, p_1.d26_1), concat.l2a(p_1.c26_1, p_1.d26_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.y2e();
        if (concat.r26()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.l28(concat.i2a(p_2.c26_1, p_2.d26_1), concat.l2a(p_2.c26_1, p_2.d26_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.d27(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  jae(target, doAnchoring, inclusive, includeFilters) {
    return this.iae(this.xad(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  kae(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.jae(target, doAnchoring, inclusive, includeFilters) : $super.jae.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  lae(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.o9k_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.xa7();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.o9k_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.t2a(Vector2D.y2a(this.pab(), this.qab()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  n9u(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.lae(doAnchoring, includeFilters) : $super.lae.call(this, doAnchoring, includeFilters);
  }
  xa7() {
    return Companion_getInstance_28().b27();
  }
  gab(name) {
    if (this.j9j_1 === name)
      return this;
    return null;
  }
  f65(type, event, result) {
    var tmp0_safe_receiver = this.n24();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.m65(type, event, result);
  }
}
class Container extends View {
  static g9y(cull, $box) {
    cull = cull === VOID ? false : cull;
    var $this = this.rb0(true, $box);
    $this.x9x_1 = cull;
    $this.y9x_1 = FastArrayList.r1j();
    $this.z9x_1 = new ContainerCollection($this, $this.y9x_1);
    $this.a9y_1 = null;
    $this.b9y_1 = new MMatrix();
    $this.c9y_1 = false;
    $this.d9y_1 = false;
    $this.e9y_1 = FastArrayList.r1j();
    return $this;
  }
  taa() {
    return this.y9x_1;
  }
  uaa() {
    super.uaa();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9x_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      if (child.m9k_1) {
        child.uaa();
      }
    }
  }
  vaa() {
    super.vaa();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9x_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      if (child.n9k_1) {
        child.vaa();
      }
    }
  }
  waa() {
    return this.y9x_1.d1();
  }
  xaa(view) {
  }
  yaa(view) {
  }
  ya7() {
    super.ya7();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.taa();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.f1(_unary__edvuaz).nad();
      }
      tmp = Unit_instance;
    }
  }
  zaa(index) {
    return this.y9x_1.f1(index);
  }
  aab(index) {
    return this.bab(index, 1) === 1;
  }
  bab(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.waa();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.zaa(removedIndex);
        view.yab(null);
        view.tab(-1);
      }
       while (inductionVariable < to);
    this.y9x_1.v6(from, to);
    var inductionVariable_0 = index;
    var last = this.waa();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.y9x_1.f1(i).tab(i);
      }
       while (inductionVariable_0 < last);
    this.iab();
    this.kab();
    this.lad();
    return to - from | 0;
  }
  cab() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9x_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      child.yab(null);
      child.tab(-1);
    }
    this.y9x_1.y2();
    this.iab();
  }
  dab(view) {
    return this.mab(view, this.waa());
  }
  f9y(view) {
    this.mab(view, this.waa());
  }
  f1(index) {
    return this.zaa(index);
  }
  aa8(ctx) {
    if (!this.ead())
      return Unit_instance;
    this.eab(ctx);
  }
  eab(ctx) {
    if (!this.x9x_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.c9y_1) {
        this.c9y_1 = true;
        this.e9y_1.y2();
        this.e9y_1.e1(this.z9x_1);
        if (this.hab())
          this.d9y_1 = false;
      }
      if (!this.d9y_1) {
        this.d9y_1 = true;
        sortWith(this.e9y_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.e9y_1.p1j_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].wa7(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.fae();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_28().b27() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.c9y_1) {
      this.c9y_1 = true;
      this.e9y_1.y2();
      this.e9y_1.e1(this.z9x_1);
      if (this.hab())
        this.d9y_1 = false;
    }
    if (!this.d9y_1) {
      this.d9y_1 = true;
      sortWith(this.e9y_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.e9y_1.p1j_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.r26() || bounds.c2f(child.eae(true))) {
        child.wa7(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  fab(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.c9y_1) {
      this.c9y_1 = true;
      this.e9y_1.y2();
      this.e9y_1.e1(this.z9x_1);
      if (this.hab())
        this.d9y_1 = false;
    }
    if (!this.d9y_1) {
      this.d9y_1 = true;
      sortWith(this.e9y_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.e9y_1.p1j_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].fab(ctx);
    }
    super.fab(ctx);
  }
  xa7() {
    var bb = Companion_getInstance_29().c27();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9x_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.f1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.kae(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  gab(name) {
    var result = super.gab(name);
    if (!(result == null))
      return result;
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z9x_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.findViewByName.<anonymous>' call
      var named = this_0.f1(_unary__edvuaz).gab(name);
      if (!(named == null))
        return named;
    }
    return null;
  }
  hab() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.y9x_1.p1j_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].eac() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  iab() {
    this.c9y_1 = false;
    this.kab();
  }
  jab(child, oldZIndex, newZIndex) {
    if (!equals(child.n24(), this))
      return Unit_instance;
    this.d9y_1 = false;
    this.kab();
  }
  kab() {
    var tmp0_safe_receiver = this.i9r();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9r();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.saa(this);
    }
  }
  lab(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  mab(view, index) {
    this.lab(view);
    var tmp0_safe_receiver = view.n24();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.iab();
    }
    view.wad();
    var aindex = clamp_1(index, 0, this.waa());
    var children = this.y9x_1;
    children.t6(aindex, view);
    var inductionVariable = aindex;
    var last = this.waa();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.f1(n).tab(n);
      }
       while (inductionVariable < last);
    view.yab(this);
    view.uaa();
    this.xaa(view);
    this.iab();
    this.kab();
    this.lad();
  }
  nab(view) {
    if (!((view == null ? null : view.n24()) === this))
      return false;
    return this.aab(view.s6b());
  }
  c65(type, event, result) {
    if (this.a9y_1 == null)
      this.a9y_1 = FastArrayList.q1j(this.z9x_1.d1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.y9x_1;
    var temp = ensureNotNull(this.a9y_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.p1j_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].l65(type, event, result);
      }
    }finally {
      temp.y2();
    }
  }
}
class CachedContainer extends Container {
  static yar(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.g9y();
    $this.jaa_1 = cache;
    $this.kaa_1 = renderQuality;
    $this.laa_1 = null;
    $this.maa_1 = true;
    $this.naa_1 = -1.0;
    $this.oaa_1 = Companion_getInstance_28().q29();
    $this.paa_1 = Scale.h2g(1);
    return $this;
  }
  qaa() {
    super.qaa();
    this.maa_1 = true;
  }
  aa8(ctx) {
    if (!this.ead())
      return Unit_instance;
    if (!this.jaa_1) {
      return super.aa8(ctx);
    }
    if (this.laa_1 == null) {
      this.laa_1 = new CacheTexture(this, ctx);
      this.maa_1 = true;
    }
    var cache = ensureNotNull(this.laa_1);
    ctx.n88(cache);
    var renderScale = ctx.d88().k3_1 === 0 ? 1.0 : ctx.v88();
    var tmp1_elvis_lhs = this.kaa_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.d88() : tmp1_elvis_lhs);
    if (this.maa_1 || !(this.naa_1 === renderScale)) {
      this.naa_1 = renderScale;
      this.oaa_1 = this.n9u(VOID, false);
      this.paa_1 = doExpensiveScaling ? this.yad().d1().j2g(this.oaa_1.d1()) : Scale.h2g(1);
      this.maa_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.oaa_1.o26_1 * renderScale * this.paa_1.x2d_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.oaa_1.p26_1 * renderScale * this.paa_1.y2d_1), 1);
      cache.eas(texWidth, texHeight);
      ctx.v7z();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.aas_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.s88(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.h7y_1;
        var this_1 = this_0.q7y_1;
        if (!(this_1.l7y_1 === this_0)) {
          this_1.l7y_1 = this_0;
          this_1.v7z();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.l6o(0, 0, frameBuffer.o6d_1, frameBuffer.p6d_1);
          var temp = this_0.o7z_1;
          this_0.y85();
          this_0.o7z_1 = scissor;
          try {
            if (true) {
              ctx.l88(Colors_getInstance().r3x_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.gad().v2a(-this.oaa_1.m26_1, -this.oaa_1.n26_1).p2a(renderScale * this.paa_1.x2d_1, renderScale * this.paa_1.y2d_1);
            ctx.v7z();
            var temp4 = ctx.w7x_1;
            var temp2d = ctx.x7x_1;
            ctx.x7x_1 = matrix;
            ctx.w7x_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.x6k(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.m6m();
              this_2.d79(_unary__edvuaz + 1 | 0);
              this_2.e79(this_2.m6m() + 1 | 0);
              var blockSize = this_2.q6k_1;
              var index0 = imul(this_2.m6m() - 1 | 0, blockSize);
              var index1 = imul(this_2.m6m(), blockSize);
              var texBlockSize = this_2.n6k_1.m6s().d1();
              var texIndex0 = imul(this_2.m6m() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.m6m(), texBlockSize);
              if (this_2.m6m() > 0) {
                arraycopy(this_2.s6k_1, index0, this_2.s6k_1, index1, blockSize);
              } else {
                arrayfill(this_2.s6k_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.n6k_1;
              this_2.t6k_1.n79($this$push.l6s(), ctx.w7x_1);
              if (true && this_2.m6m() >= 1) {
                var equals = arrayequal(this_2.s6k_1, index0, this_2.s6k_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.m6m();
                  this_2.d79(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.aa8(ctx);
            }finally {
              ctx.v7z();
              ctx.w7x_1 = temp4;
              ctx.x7x_1 = temp2d;
              ctx.x6k(ProjViewUB_getInstance()).f79();
            }
            break $l$block_0;
          }finally {
            this_0.y85();
            this_0.o7z_1 = temp;
          }
        }
      }finally {
        ctx.t88();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.h7y_1;
    var this_4 = this_3.q7y_1;
    if (!(this_4.l7y_1 === this_3)) {
      this_4.l7y_1 = this_3;
      this_4.v7z();
    }
    this_3.x7z(cache.cas_1, VOID, VOID, VOID, VOID, this.p9u().z2a(this.oaa_1.m26_1, this.oaa_1.n26_1).r2a(1.0 / (renderScale * this.paa_1.x2d_1), 1.0 / (renderScale * this.paa_1.y2d_1)), VOID, this.jad(), this.k9j_1);
  }
  raa() {
    return this;
  }
  saa(view) {
    this.maa_1 = true;
    var tmp0_safe_receiver = this.n24();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i9j_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.saa(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static haj(size, cache, clip) {
    size = size === VOID ? Size2D.j27(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.yar(cache);
    $this.eaj_1 = clip;
    $this.faj_1 = size;
    $this.gaj_1 = Ref(false);
    return $this;
  }
  ua7(_set____db54di) {
    this.faj_1 = _set____db54di;
  }
  va7() {
    return this.faj_1;
  }
  xa7() {
    return new Rectangle(0.0, 0.0, this.w2i(), this.x2i());
  }
  aa8(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.eaj_1;
      var renderingInternalRef = this.gaj_1;
      if (renderingInternalRef.o1()) {
        super.aa8(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.p9u();
        var hasRotation = !(m.t29_1 === 0.0) || !(m.u29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.o1();
          try {
            renderingInternalRef.t2q(true);
            renderFiltered(this, ctx, Companion_getInstance_49());
          }finally {
            renderingInternalRef.t2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.h7y_1;
        if (!(ctx.l7y_1 === batcher)) {
          ctx.l7y_1 = batcher;
          ctx.v7z();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.j7y_1;
        var bounds = this.cae(ctx).n2f(ctx.x7x_1).o2f();
        var rect = c2d.z88_1.i85().t6o();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.c2f(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().o6o(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.z88_1;
            var scissor_0 = c2d.h89(scissor);
            var temp = this_0.o7z_1;
            this_0.y85();
            this_0.o7z_1 = scissor_0;
            try {
              super.aa8(ctx);
              break $l$block_1;
            }finally {
              this_0.y85();
              this_0.o7z_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.aa8(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.aa8(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static pa7(size, cache) {
    Companion_getInstance_40();
    size = size === VOID ? Companion_getInstance_40().oag_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.haj(size, cache, false);
    $this.na7_1 = size;
    $this.oa7_1 = false;
    return $this;
  }
  ua7(value) {
    if (!this.na7_1.equals(value)) {
      this.na7_1 = value;
      this.ra7();
    }
  }
  va7() {
    return this.na7_1;
  }
  xa7() {
    return new Rectangle(0.0, 0.0, this.w2i(), this.x2i());
  }
  ra7() {
    var tmp0_safe_receiver = this.n24();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yaa(this);
    }
  }
  ya7() {
    super.ya7();
    this.za7();
  }
  za7() {
    this.uaa();
  }
  aa8(ctx) {
    registerUISupportOnce(this);
    super.aa8(ctx);
  }
}
class SceneContainer extends UIView {
  static u9n(views, defaultTransition, name, size) {
    Companion_getInstance_39();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.t9h_1.d1() : size;
    var $this = this.pa7(size);
    $this.o9n_1 = views;
    $this.p9n_1 = defaultTransition;
    $this.j9j_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.qa7();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.f9y(this_0);
    tmp.q9n_1 = this_0;
    $this.r9n_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.y64(tmp_0, SceneContainer$lambda($this));
    $this.s9n_1 = arrayListOf([Companion_getInstance_39().ya1_1]);
    $this.t9n_1 = 0;
    return $this;
  }
  ra7() {
    var tmp0_safe_receiver = this.r9n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ca1(Size2D.s2e(this.w2i(), this.x2i()));
    }
  }
  sa7(clazz, injects, time, transition, $completion) {
    this.ta7(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  v9n(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.p9n_1 : transition;
    return $super === VOID ? this.sa7(clazz, injects, time, transition, $completion) : $super.sa7.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  za1(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  ta7(entry) {
    while (this.s9n_1.d1() <= this.t9n_1) {
      this.s9n_1.h(Companion_getInstance_39().ya1_1);
    }
    this.s9n_1.z2(this.t9n_1, entry);
  }
  ds() {
    return this.o9n_1.h9g_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static qa7() {
    var $this = this.g9y();
    dummyView($this);
    dummyView($this);
    $this.oa4_1 = Companion_getInstance_34().m1i_1;
    $this.pa4_1 = get_AlphaTransition();
    return $this;
  }
  m15() {
    return this.f1(0);
  }
  j15() {
    return this.f1(1);
  }
  ra4(next, transition) {
    this.pa4_1 = transition;
    this.oa4_1 = Companion_getInstance_34().m1i_1;
    this.qa4_1 = transition.pae();
    this.qae(this.j15(), next);
    _get_transitionProcess__5hlux5(this).mae(this.m15(), this.j15());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.oa4_1) + ':transition=' + toString(this.pa4_1));
  }
  sa4() {
    this.oa4_1 = Companion_getInstance_34().p1i_1;
    _get_transitionProcess__5hlux5(this).nae(this.m15(), this.j15());
    this.qae(dummyView(this), this.j15());
  }
  qae(prev, next) {
    this.cab();
    this.dab(prev);
    this.dab(next);
  }
  aa8(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.oa4_1, Companion_getInstance_34().m1i_1) <= 0) {
      this.m15().wa7(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.oa4_1, Companion_getInstance_34().p1i_1) >= 0) {
      this.j15().wa7(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).oae(ctx, this.m15(), this.j15(), this.oa4_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.rae_1 = $render;
    this.sae_1 = $name;
  }
  pae() {
    return this;
  }
  oae(ctx, prev, next, ratio) {
    return this.rae_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.sae_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.tae_1 = $process;
    this.uae_1 = $easing;
  }
  mae(prev, next) {
    return this.tae_1.mae(prev, next);
  }
  nae(prev, next) {
    return this.tae_1.nae(prev, next);
  }
  oae(ctx, prev, next, ratio) {
    return this.tae_1.oae(ctx, prev, next, this.uae_1.h1i(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.vae_1 = $this_withEasing;
    this.wae_1 = $easing;
  }
  toString() {
    return toString(this.vae_1) + '.withEasing';
  }
  pae() {
    var process = this.vae_1.pae();
    return new withEasing$1$create$1(process, this.wae_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.xae_1 = this.baf(true, VOID, false);
    this.yae_1 = this.baf(true, VOID, true);
    this.zae_1 = this.caf(false, 'r', false);
    this.aaf_1 = this.caf(false, 'a', false);
  }
  caf(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().u84_1;
    var tmp2_name = name == null ? Companion_getInstance_6().u84_1.j6l_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.q6u();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.h6w();
    var tmp_0 = this_0.h6w();
    var tmp_1 = this_0.h6w();
    var tmp_2 = this_0.h6w();
    var median$delegate = this_0.w6v(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).y6s(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().r84_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.b6w(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.p6w(this_0.j6v());
    var alpha = this_0.q6w(this_0.j6v());
    this_0.v6u(this_0.y6u(), this_0.u6w(this_0.y6u(), this_0.c6v([this_0.b6v(0.5)])));
    if (msdf) {
      this_0.v6u(d, this_0.z6v(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.e6v(this_0.y6u(), 'r'), this_0.e6v(this_0.y6u(), 'g'), this_0.e6v(this_0.y6u(), 'b')));
    } else {
      this_0.v6u(d, this_0.e6v(this_0.y6u(), sdf));
    }
    this_0.v6u(alpha, this_0.y6v(SDFShaders_getInstance().j8a(), d));
    if (inverted) {
      this_0.v6u(alpha, this_0.u6w(this_0.b6v(1.0), alpha));
    }
    this_0.v6u(this_0.y6u(), this_0.z6u(this_0.w6u(), alpha));
    var tmp3_fragment = FragmentShader(this_0.d6v());
    return tmp1_$this.b7i(VOID, tmp3_fragment, tmp2_name);
  }
  baf(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.caf(msdf, sdf, inverted) : $super.caf.call(this, msdf, sdf, inverted);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.t1v() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.t1v() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.daf_1 = view;
    this.eaf_1 = vs;
    this.faf_1 = fastTime;
    this.gaf_1 = easing;
    this.haf_1 = callback;
    this.iaf_1 = c;
    this.jaf_1 = fastWaitTime;
    this.kaf_1 = autoInvalidate;
    this.laf_1 = Companion_instance_1.s1v();
    var tmp = this;
    var tmp_0;
    if (!equals(this.faf_1, Companion_instance_1.t1v())) {
      tmp_0 = this.faf_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.eaf_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.s8b_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.maf_1 = tmp_0;
    this.naf_1 = false;
    this.oaf_1 = false;
    this.paf_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.qaf_1 = this.daf_1.y64(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.iaf_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cv(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.s1v());
  }
  xaf() {
    return get_slow(this.jaf_1);
  }
  yaf() {
    if (this.paf_1)
      return Unit_instance;
    this.paf_1 = true;
    var tmp0_safe_receiver = this.iaf_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.nc(tmp$ret$0);
    }
  }
  waf() {
    if (this.oaf_1)
      return Unit_instance;
    this.oaf_1 = true;
    var tmp0_safe_receiver = this.qaf_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.y5();
    }
    this.qaf_1 = null;
    this.yaf();
  }
  raf(elapsed) {
    if (equals(elapsed, Companion_instance_1.s1v())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.eaf_1;
      var n = 0;
      while (n < this_0.d1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.f1(_unary__edvuaz).y35();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.eaf_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.f1(_unary__edvuaz_0);
      var durationInTween = equals(v.q8b_1, Companion_instance_1.t1v()) ? FastDuration__minus_impl_evs237(this.maf_1, v.p8b_1) : v.q8b_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.p8b_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7(durationInTween, Companion_getInstance().hj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7_0(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.gaf_1.g1i(ratioInTween);
      v.v8b(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.daf_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.zaf_1 = $this_tween;
    this.aag_1 = $tc;
    this.bag_1 = $vs;
    this.cag_1 = $time;
    this.dag_1 = $easing;
    this.eag_1 = $callback;
    this.fag_1 = $waitTime;
    this.gag_1 = $autoInvalidate;
  }
  h1b($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UIObservable {
  constructor(initial, observe) {
    this.hag_1 = initial;
    this.iag_1 = observe;
    this.jag_1 = this.hag_1;
  }
  kag(obj, prop) {
    return this.jag_1;
  }
  lag(obj, prop, value) {
    if (!equals(this.jag_1, value)) {
      this.jag_1 = value;
      this.iag_1(value);
    }
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.mag_1 = 90.0;
    this.nag_1 = 32.0;
    this.oag_1 = Size2D.o2e(90.0, 32.0);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.qao_1 = 1.0;
    this.rao_1 = 1.0;
    this.sao_1 = 1.0;
    this.tao_1 = 1.0;
    this.uao_1 = 1.0;
    this.vao_1 = MatrixTransform.z2b();
  }
  wao(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.vao_1 = globalMatrix.d2b();
      // Inline function 'kotlin.math.abs' call
      var x = this.vao_1.r2b_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.vao_1.s2b_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.sao_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.tao_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.sao_1 = sx;
        this.tao_1 = sy;
        this.uao_1 = sxy;
        this.qao_1 = 1.0 / sx;
        this.rao_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.sao_1 = 1.0;
      this.tao_1 = 1.0;
      this.uao_1 = 1.0;
      this.qao_1 = 1.0;
      this.rao_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static sbf(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.lb6();
    $this.gar_1 = smoothing;
    $this.war(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.har_1 = get_Bitmaps_white();
    $this.iar_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_15();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.jar_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.kar_1 = null;
    $this.lar_1 = null;
    return $this;
  }
  tar(v) {
    if (!(this.har_1 === v)) {
      this.har_1 = v;
      this.j9k_1 = true;
      this.qaa();
    }
  }
  iaj(v) {
    if (!this.iar_1.equals(v)) {
      this.iar_1 = v;
      this.j9k_1 = true;
      this.qaa();
    }
  }
  mar() {
    return this.iar_1;
  }
  eap() {
    return 0.0;
  }
  fap() {
    return 0.0;
  }
  pab() {
    return this.mar().m25_1 * this.eap();
  }
  qab() {
    return this.mar().n25_1 * this.fap();
  }
  nar() {
    return -this.pab();
  }
  oar() {
    return -this.qab();
  }
  aa8(ctx) {
    if (!this.ead())
      return Unit_instance;
    var tmp = this.har_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.j9k_1) {
      this.j9k_1 = false;
      this.var();
    }
    this.uar(ctx);
  }
  uar(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.h7y_1;
    var this_1 = this_0.q7y_1;
    if (!(this_1.l7y_1 === this_0)) {
      this_1.l7y_1 = this_0;
      this_1.v7z();
    }
    var tmp0_safe_receiver = this.lar_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.jar_1;
    var tex = ctx.m88(this.har_1).s3h();
    var smoothing = this.gar_1;
    var blendMode = this.iad();
    var program = this.kar_1;
    var vcount = array.s85_1;
    var icount = array.t85_1;
    var matrix = Companion_getInstance_30().o29_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.s82_1;
      this_0.l85(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().u84_1 : program;
      if (this_0.a86(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.c85();
      if (!contains(this_0.g7z_1, tex_0)) {
        this_0.f7z_1 = 0;
        this_0.g7z_1[0] = tex_0;
      }
      this_0.h7z_1 = smoothing;
      this_0.i7z_1 = blendMode;
      this_0.j7z_1 = pprogram;
    }
    this_0.x85(array, matrix, vcount, icount);
  }
  var() {
    this.jar_1.u8a(0, this.nar(), this.oar(), this.eap(), this.fap(), this.p9u(), this.har_1, this.jad());
  }
  xa7() {
    return Companion_getInstance_28().n2e(this.nar(), this.oar(), this.eap(), this.fap());
  }
  toString() {
    var out = super.toString();
    if (!this.mar().equals(Companion_getInstance_25().d25_1))
      out = out + (':anchor=(' + this.rad(this.mar().m25_1) + ', ' + this.rad(this.mar().n25_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static ibf(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.sbf(anchor, hitShape, smoothing);
    $this.nao_1 = false;
    $this.oao_1 = bitmap;
    $this.qar();
    return $this;
  }
  static yao(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.ibf(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  dap(value) {
    if (equals(this.har_1, value))
      return Unit_instance;
    this.nao_1 = true;
    this.tar(value);
  }
  e58() {
    return this.har_1;
  }
  qar() {
    if (this.nao_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  aa8(ctx) {
    this.qar();
    super.aa8(ctx);
  }
  eap() {
    return this.har_1.w2i();
  }
  fap() {
    return this.har_1.x2i();
  }
  l3i() {
    return this.har_1.l3i();
  }
  m3i() {
    return this.har_1.m3i();
  }
  v3h() {
    return this.har_1.v3h();
  }
  w3h() {
    return this.har_1.w3h();
  }
  rar() {
    return this.mar().m25_1 * this.v3h();
  }
  sar() {
    return this.mar().n25_1 * this.w3h();
  }
  pab() {
    return this.rar() - this.l3i();
  }
  qab() {
    return this.sar() - this.m3i();
  }
  xa7() {
    return Companion_getInstance_28().n2e(-this.rar(), -this.sar(), this.v3h(), this.w3h());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.e58()));
  }
}
class BaseGraphics extends BaseImage {
  static xao(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.yao(tmp$ret$0);
    $this.ral_1 = autoScaling;
    $this.sal_1 = true;
    $this.tal_1 = false;
    $this.ual_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.val_1 = ArrayList.i1();
    $this.wal_1 = new InternalViewAutoscaling();
    $this.xal_1 = 1;
    $this.yal_1 = true;
    $this.zal_1 = true;
    $this.aam_1 = null;
    $this.bam_1 = 1.0;
    $this.cam_1 = 1.0;
    $this.dam_1 = true;
    $this.eam_1 = true;
    $this.fam_1 = Companion_getInstance_28().q29();
    $this.gam_1 = Companion_getInstance_28().q29();
    return $this;
  }
  zao(value) {
    this.sal_1 = value;
    this.aap();
  }
  aap() {
    this.yal_1 = true;
    this.zal_1 = true;
    this.lad();
  }
  ya7() {
    super.ya7();
    if (this.n24() == null || this.i9r() == null) {
      var tmp = this.e58().s3h();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.val_1.h(this.e58().s3h());
      }
      clearBitmaps(this, true);
    }
  }
  aa8(ctx) {
    this.aam_1 = ctx;
    clearBitmaps(this, false);
    this.bap();
    super.aa8(ctx);
  }
  bap() {
    if (this.wal_1.wao(this.ral_1, this.tal_1, this.p9u())) {
      this.yal_1 = true;
    }
    if (!this.yal_1)
      return false;
    this.yal_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.val_1.h(this.e58().s3h());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.o26_1 * this.wal_1.sao_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.p26_1 * this.wal_1.tao_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.xal_1 | 0, imageHeight + this.xal_1 | 0, this.sal_1, true);
    this.bam_1 = this.wal_1.sao_1;
    this.cam_1 = this.wal_1.tao_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.j3w_1;
    if (true) {
      image.s3w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.b44(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.t56(this.bam_1, this.cam_1);
        ctx.x4p(-boundsWithShapes.m26_1, -boundsWithShapes.n26_1);
        this.cap(ctx);
      }finally {
        ctx.ov();
      }
    }finally {
      result = true ? image.u3w(rect) : 0;
    }
    this.dap(slice(image));
    return true;
  }
  eap() {
    return _get_bitmapWidth__ndy7bu(this) / this.bam_1;
  }
  fap() {
    return _get_bitmapHeight__5t1vx1(this) / this.cam_1;
  }
  v3h() {
    return this.eap();
  }
  w3h() {
    return this.fap();
  }
  pab() {
    return this.mar().m25_1 * this.eap();
  }
  qab() {
    return this.mar().n25_1 * this.fap();
  }
  nar() {
    return _getLocalBoundsInternal(this, this.dam_1).m26_1;
  }
  oar() {
    return _getLocalBoundsInternal(this, this.dam_1).n26_1;
  }
  xa7() {
    return _getLocalBoundsInternal$default(this);
  }
  par(value) {
    this.eam_1 = value;
    this.lad();
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.das_1 = $outer;
    this.zar_1 = ctx;
    this.aas_1 = this.zar_1.q88(16, 16, VOID, VOID, VOID, false);
    this.bas_1 = TextureBase.v82(this.aas_1.m6i(), 16, 16);
    this.cas_1 = Texture(this.bas_1);
  }
  eas(width, height) {
    this.aas_1.o6i(0, 0, width, height);
    this.bas_1.w82(width);
    this.bas_1.x82(height);
    this.cas_1 = Texture(this.bas_1);
  }
  y5() {
    this.das_1.laa_1 = null;
    this.zar_1.r88(this.aas_1);
  }
}
class ShapeView extends Container {
  static zax(shape, fill, stroke, strokeThickness, autoScaling, renderer) {
    shape = shape === VOID ? null : shape;
    fill = fill === VOID ? new RGBA(Colors_getInstance().m3x_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().m3x_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 1.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.g9y();
    $this.nau_1 = addTo(Graphics.nbc(VOID, renderer), $this);
    $this.nau_1.rbc(autoScaling);
    $this.oau_1 = anchor$factory($this.nau_1);
    $this.pau_1 = antialiased$factory($this.nau_1);
    $this.qau_1 = autoScaling$factory($this.nau_1);
    $this.rau_1 = renderer$factory($this.nau_1);
    $this.sau_1 = smoothing$factory($this.nau_1);
    $this.tau_1 = boundsIncludeStrokes$factory($this.nau_1);
    $this.uau_1 = shape;
    $this.vau_1 = fill;
    $this.wau_1 = stroke;
    $this.xau_1 = numberToDouble(strokeThickness);
    $this.xax();
    $this.yau_1 = new VectorPath();
    return $this;
  }
  iaj(_set____db54di) {
    var this_0 = this.oau_1;
    anchor$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  mar() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.oau_1;
    anchor$factory_1();
    return this_0.get();
  }
  pab() {
    return this.nau_1.pab();
  }
  qab() {
    return this.nau_1.qab();
  }
  m22() {
    return this.uau_1;
  }
  cay(value) {
    if (equals(this.vau_1, value))
      return Unit_instance;
    this.vau_1 = value;
    this.xax();
  }
  day(value) {
    if (equals(this.wau_1, value))
      return Unit_instance;
    this.wau_1 = value;
    this.xax();
  }
  eay(value) {
    if (this.xau_1 === value)
      return Unit_instance;
    this.xau_1 = value;
    this.xax();
  }
  xax() {
    // Inline function 'korlibs.korge.view.Graphics.updateShape' call
    var this_0 = this.nau_1;
    var result;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_1 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
    var shapeView = this;
    var shape = shapeView.m22();
    if (!(shape == null) && shape.m28()) {
      if (!(shapeView.xau_1 === 0.0)) {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = shapeView.vau_1;
        var stroke = shapeView.wau_1;
        var strokeInfo = new StrokeInfo(shapeView.xau_1);
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.s56(shape);
        if (!(fill == null)) {
          this_1.y4n(fill);
        }
        if (!(stroke == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.k38_1;
              var lineCap = strokeInfo.n38_1;
              var lineJoin = strokeInfo.p38_1;
              var miterLimit = strokeInfo.q38_1;
              var lineDash = strokeInfo.r38_1;
              var lineDashOffset = strokeInfo.s38_1;
              if (false) {
                this_1.m4m();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              this_1.f4o();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                this_1.g4o(numberToDouble(lineWidth));
                this_1.h4o(lineCap);
                this_1.i4o(lineJoin);
                this_1.j4o(numberToDouble(miterLimit));
                this_1.k4o(lineDash);
                this_1.l4o(numberToDouble(lineDashOffset));
                this_1.m4o(stroke);
              }finally {
                this_1.n4o();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = this_1.z4n();
            var lineCap_0 = this_1.a4o();
            var lineJoin_0 = this_1.b4o();
            var miterLimit_0 = this_1.c4o();
            var lineDash_0 = this_1.d4o();
            var lineDashOffset_0 = this_1.e4o();
            if (false) {
              this_1.m4m();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            this_1.f4o();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              this_1.g4o(numberToDouble(lineWidth_0));
              this_1.h4o(lineCap_0);
              this_1.i4o(lineJoin_0);
              this_1.j4o(numberToDouble(miterLimit_0));
              this_1.k4o(lineDash_0);
              this_1.l4o(numberToDouble(lineDashOffset_0));
              this_1.m4o(stroke);
            }finally {
              this_1.n4o();
            }
          }
        }
      } else {
        // Inline function 'korlibs.image.vector.Context2d.fill' call
        var paint = shapeView.vau_1;
        if (true) {
          this_1.m4m();
        }
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.s56(shape);
        this_1.j5p(paint, null);
      }
    }
    result = Unit_instance;
    var tmp$ret$4 = this_1.u4k();
    this_0.lbc(tmp$ret$4);
  }
}
class Circle_0 extends ShapeView {
  static yax(radius, fill, stroke, strokeThickness, autoScaling, renderer) {
    radius = radius === VOID ? 16.0 : radius;
    fill = fill === VOID ? new RGBA(Colors_getInstance().m3x_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().m3x_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.zax(new VectorPath(), fill, stroke, strokeThickness, autoScaling, renderer);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var value = numberToDouble(radius);
    var observe = Circle$radius$delegate$lambda($this);
    tmp.tax_1 = new UIObservable(value, observe);
    $this.uax_1 = colorMul$factory($this);
    updateGraphics($this);
    return $this;
  }
  aay(_set____db54di) {
    return this.tax_1.lag(this, radius$factory(), _set____db54di);
  }
  vax() {
    return this.tax_1.kag(this, radius$factory_0());
  }
  bay(_set____db54di) {
    var this_0 = this.uax_1;
    color$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  o53() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.uax_1;
    color$factory_0();
    return this_0.get().i4d_1;
  }
}
class ZIndexComparator {
  fay(a, b) {
    return compareTo(a.eac(), b.eac());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.fay(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.wb0_1 = this$0;
    this.vb0_1 = 0;
  }
  b1() {
    return this.vb0_1 < this.wb0_1.tb0_1.waa();
  }
  c1() {
    var _unary__edvuaz = this.vb0_1;
    this.vb0_1 = _unary__edvuaz + 1 | 0;
    return this.wb0_1.tb0_1.zaa(_unary__edvuaz);
  }
  c6() {
    this.vb0_1 = this.vb0_1 - 1 | 0;
    this.wb0_1.tb0_1.aab(this.vb0_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.sb0_1 = children;
    this.tb0_1 = container;
  }
  d1() {
    return this.tb0_1.waa();
  }
  xb0(element) {
    return element.n24() === this.tb0_1;
  }
  k1(element) {
    if (!(element instanceof View))
      return false;
    return this.xb0(element instanceof View ? element : THROW_CCE());
  }
  yb0(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.n24() === this.tb0_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  t2(elements) {
    return this.yb0(elements);
  }
  g1() {
    return this.tb0_1.waa() === 0;
  }
  zb0(element) {
    this.tb0_1.dab(element);
    return true;
  }
  h(element) {
    return this.zb0(element instanceof View ? element : THROW_CCE());
  }
  ab1(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.tb0_1.dab(element);
    }
    return true;
  }
  e1(elements) {
    return this.ab1(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  bb1(element) {
    return this.tb0_1.nab(element);
  }
  x2(element) {
    if (!(element instanceof View))
      return false;
    return this.bb1(element instanceof View ? element : THROW_CCE());
  }
  f1(index) {
    return this.sb0_1.f1(index);
  }
  u2() {
    return this.sb0_1.u2();
  }
  v2(index) {
    return this.sb0_1.v2(index);
  }
  w2(fromIndex, toIndex) {
    return this.sb0_1.w2(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static ib4(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.xao(autoScaling);
    $this.ab4_1 = 0;
    $this.bb4_1 = null;
    $this.cb4_1 = true;
    $this.db4_1 = -1;
    $this.eb4_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.fb4_1 = ArrayList.i1();
    $this.gb4_1 = null;
    $this.hb4_1 = null;
    $this.t9k_1 = true;
    return $this;
  }
  jb4(value) {
    this.bb4_1 = value;
    this.ab4_1 = this.ab4_1 + 1 | 0;
    this.aap();
  }
  war(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.hb4_1 = tmp_0;
  }
  rab() {
    var tmp0_safe_receiver = this.sab();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  sab() {
    if (!(this.hb4_1 == null))
      return this.hb4_1;
    if (!(this.db4_1 === this.ab4_1)) {
      this.db4_1 = this.ab4_1;
      this.fb4_1.y2();
      var tmp = this.fb4_1;
      var tmp0_safe_receiver = this.bb4_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j4r();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.fb4_1;
  }
  cap(ctx) {
    var tmp0_safe_receiver = this.bb4_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.q4q(ctx);
    }
  }
  pao(includeStrokes) {
    var tmp0_safe_receiver = this.bb4_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u5q(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_28().y26_1 : tmp1_elvis_lhs;
  }
}
class DummyView extends View {
  static kb6() {
    return this.lb6();
  }
  aa8(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class FixedSizeContainer extends Container {
  static mb6(size, clip) {
    size = size === VOID ? Size2D.j27(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.g9y();
    $this.ob0_1 = clip;
    $this.pb0_1 = size;
    $this.qb0_1 = Ref(false);
    return $this;
  }
  c5r() {
    return this.ob0_1;
  }
  ua7(_set____db54di) {
    this.pb0_1 = _set____db54di;
  }
  va7() {
    return this.pb0_1;
  }
  xa7() {
    return new Rectangle(0.0, 0.0, this.w2i(), this.x2i());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.w2i()) + 'x' + get_niceStr(this.x2i()) + ')');
    return out;
  }
  aa8(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.c5r();
      var renderingInternalRef = this.qb0_1;
      if (renderingInternalRef.o1()) {
        super.aa8(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.p9u();
        var hasRotation = !(m.t29_1 === 0.0) || !(m.u29_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.o1();
          try {
            renderingInternalRef.t2q(true);
            renderFiltered(this, ctx, Companion_getInstance_49());
          }finally {
            renderingInternalRef.t2q(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.h7y_1;
        if (!(ctx.l7y_1 === batcher)) {
          ctx.l7y_1 = batcher;
          ctx.v7z();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.j7y_1;
        var bounds = this.cae(ctx).n2f(ctx.x7x_1).o2f();
        var rect = c2d.z88_1.i85().t6o();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.c2f(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().o6o(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.z88_1;
            var scissor_0 = c2d.h89(scissor);
            var temp = this_0.o7z_1;
            this_0.y85();
            this_0.o7z_1 = scissor_0;
            try {
              super.aa8(ctx);
              break $l$block_1;
            }finally {
              this_0.y85();
              this_0.o7z_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.aa8(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.aa8(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static ua0(size, clip) {
    size = size === VOID ? Size2D.j27(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.mb6(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.ob6_1 = capacity;
    this.pb6_1 = IntDeque.k2m(this.ob6_1);
    this.qb6_1 = 0;
  }
  d1() {
    return this.pb6_1.d1();
  }
  rb6() {
    return this.pb6_1.d1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.qb6_1 / this.pb6_1.d1());
  }
  sb6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.rb6());
  }
  tb6(index) {
    return get_fastMicroseconds_0(this.pb6_1.f1(index));
  }
  ub6(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.pb6_1.p2m(intValue);
    this.qb6_1 = this.qb6_1 + intValue | 0;
    if (this.pb6_1.d1() > this.ob6_1) {
      this.qb6_1 = this.qb6_1 - this.pb6_1.jk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static nbc(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.g9y();
    $this.db9_1 = null;
    $this.eb9_1 = null;
    $this.fb9_1 = true;
    $this.gb9_1 = false;
    $this.hb9_1 = true;
    $this.ib9_1 = true;
    $this.jb9_1 = EmptyShape_instance;
    $this.kb9_1 = renderer;
    $this.lbc(shape);
    return $this;
  }
  obc() {
    var tmp0_elvis_lhs = this.db9_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.eb9_1 : tmp0_elvis_lhs);
  }
  par(value) {
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.par(value);
    }
    var tmp1_safe_receiver = this.eb9_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.par(value);
    }
    this.qaa();
    this.lad();
  }
  pbc() {
    var tmp0_safe_receiver = this.db9_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.eam_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.eb9_1;
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.obb_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  }
  iaj(value) {
    _get_anchorable__ebfoik(this).iaj(value);
    this.qaa();
  }
  mar() {
    return _get_anchorable__ebfoik(this).mar();
  }
  pab() {
    return this.obc().pab();
  }
  qab() {
    return this.obc().qab();
  }
  mbc(value) {
    if (this.fb9_1 === value)
      return Unit_instance;
    this.fb9_1 = value;
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cb4_1 = value;
    }
    var tmp1_safe_receiver = this.eb9_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.mbc(value);
    }
    this.qaa();
  }
  qbc(value) {
    if (this.hb9_1 === value)
      return Unit_instance;
    this.hb9_1 = value;
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.gar_1 = value;
    }
    var tmp1_safe_receiver = this.eb9_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.nbb_1 = value;
    }
    this.qaa();
  }
  rbc(value) {
    if (this.ib9_1 === value)
      return Unit_instance;
    this.ib9_1 = value;
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ral_1 = value;
    }
    var tmp1_safe_receiver = this.eb9_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.lbb_1 = value;
    }
    this.qaa();
  }
  lbc(value) {
    if (this.jb9_1 === value)
      return Unit_instance;
    this.jb9_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jb4(value);
    }
    var tmp1_safe_receiver = this.eb9_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.lbc(value);
    }
    this.qaa();
  }
  sbc(value) {
    if (this.kb9_1 === value)
      return Unit_instance;
    this.kb9_1 = value;
    this.tbc();
  }
  tbc() {
    ensure(this);
    var tmp0_safe_receiver = this.db9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.aap();
    }
    var tmp1_safe_receiver = this.db9_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.bap();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.e9h_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.mbf(views, currentVfs, sourceFile, $completion) : $super.mbf.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static hbf(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ibf(bitmap, anchor, hitShape, smoothing);
    $this.cbf_1 = new Mixin_0();
    $this.dbf_1 = sourceFile$factory($this);
    return $this;
  }
  static jbf(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.hbf(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  static kbf(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().d25_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.jbf(slice(bitmap), anchor, hitShape, smoothing);
  }
  aa8(ctx) {
    this.lbf(ctx, this);
    super.aa8(ctx);
  }
  mbf(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  obf(_set____db54di) {
    this.cbf_1.fbf_1 = _set____db54di;
  }
  pbf(_set____db54di) {
    this.cbf_1.pbf(_set____db54di);
  }
  qbf() {
    return this.cbf_1.gbf_1;
  }
  ebf(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  lbf(ctx, view) {
    this.cbf_1.lbf(ctx, view);
  }
}
class RoundRect extends ShapeView {
  static qbi(size, radius, fill, stroke, strokeThickness, autoScaling) {
    fill = fill === VOID ? new RGBA(Colors_getInstance().m3x_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().m3x_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.zax(new VectorPath(), fill, stroke, strokeThickness, autoScaling);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe = RoundRect$unscaledSize$delegate$lambda($this);
    tmp.nbi_1 = new UIObservable(size, observe);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe_0 = RoundRect$radius$delegate$lambda($this);
    tmp_0.obi_1 = new UIObservable(radius, observe_0);
    $this.pbi_1 = colorMul$factory_0($this);
    updateGraphics_0($this);
    return $this;
  }
  ua7(_set____db54di) {
    return this.nbi_1.lag(this, unscaledSize$factory(), _set____db54di);
  }
  va7() {
    return this.nbi_1.kag(this, unscaledSize$factory_0());
  }
  rbi(_set____db54di) {
    return this.obi_1.lag(this, radius$factory_1(), _set____db54di);
  }
  vax() {
    return this.obi_1.kag(this, radius$factory_2());
  }
  bay(_set____db54di) {
    var this_0 = this.pbi_1;
    color$factory_1();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  o53() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.pbi_1;
    color$factory_2();
    return this_0.get().i4d_1;
  }
}
class Companion_5 {}
class Companion_6 {}
class SolidRect extends RectBase {
  static zbk(size, color) {
    color = color === VOID ? Colors_getInstance().m3x_1 : color;
    var $this = this.sbf();
    $this.ybk_1 = size;
    $this.y4c(color);
    return $this;
  }
  ua7(value) {
    if (this.ybk_1.equals(value))
      return Unit_instance;
    this.ybk_1 = value;
    this.j9k_1 = true;
    this.qaa();
  }
  va7() {
    return this.ybk_1;
  }
  eap() {
    return this.w2i();
  }
  fap() {
    return this.x2i();
  }
  bay(value) {
    this.y4c(value);
  }
}
class Stage extends FixedSizeContainer {
  static s9f(views) {
    var $this = this.mb6();
    $this.o9f_1 = views.r9g_1;
    $this.p9f_1 = views;
    $this.q9f_1 = clipBorders$factory($this.j9r());
    $this.r9f_1 = virtualSizeDouble$factory($this.j9r());
    $this.uab($this);
    $this.wab($this);
    return $this;
  }
  j9r() {
    return this.p9f_1;
  }
  abl(_set____db54di) {
    var this_0 = this.q9f_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  c5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q9f_1;
    clip$factory_0();
    return this_0.get();
  }
  ua7(_set____db54di) {
    var this_0 = this.r9f_1;
    unscaledSize$factory_1();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  va7() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r9f_1;
    unscaledSize$factory_2();
    return this_0.get();
  }
  i9r() {
    return this;
  }
  raa() {
    return this;
  }
  o81() {
    return this.ub0(this.j9r());
  }
  saa(view) {
    this.j9r().saa(view);
  }
  toString() {
    return 'Stage';
  }
  ds() {
    return this.p9f_1.h9g_1;
  }
  e87(pos) {
    return this.o9f_1.e87(pos);
  }
  t86(value) {
    this.o9f_1.t86(value);
  }
  u86() {
    return this.o9f_1.u86();
  }
  v86(value) {
    this.o9f_1.v86(value);
  }
  w86() {
    return this.o9f_1.w86();
  }
  x86(value) {
    this.o9f_1.x86(value);
  }
  y86() {
    return this.o9f_1.y86();
  }
  z86(value) {
    this.o9f_1.z86(value);
  }
  a87() {
    return this.o9f_1.a87();
  }
  b87(value) {
    this.o9f_1.b87(value);
  }
  c87() {
    return this.o9f_1.c87();
  }
  d87() {
    return this.o9f_1.d87();
  }
}
class Companion_7 {
  constructor() {
    this.cbp_1 = 16.0;
    this.dbp_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.dbl_1 = this$0;
    this.ebl_1 = $ctx;
    this.fbl_1 = $fontSource;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static gbp(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_22.cbp_1 : textSize;
    color = color === VOID ? Colors_getInstance().m3x_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().s4l_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_22.dbp_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.g9y();
    $this.obn_1 = true;
    $this.pbn_1 = -1;
    $this.qbn_1 = -1;
    $this.rbn_1 = 0;
    $this.sbn_1 = 0;
    $this.tbn_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.ubn_1 = fill == null ? new RGBA(color) : fill;
    $this.vbn_1 = stroke;
    $this.wbn_1 = font;
    $this.xbn_1 = numberToDouble(textSize);
    $this.ybn_1 = textSize$factory($this);
    $this.zbn_1 = 0;
    $this.abo_1 = 2147483647;
    $this.bbo_1 = renderer;
    $this.cbo_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.g9y(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.dbo_1 = addTo(this_0, $this);
    $this.ebo_1 = new Text2TextRendererActions();
    $this.fbo_1 = false;
    $this.gbo_1 = autoScaling;
    $this.hbo_1 = false;
    $this.ibo_1 = null;
    $this.jbo_1 = Companion_getInstance_28().m2e(0, 0, 2048, 2048);
    $this.kbo_1 = true;
    $this.lbo_1 = -1;
    $this.mbo_1 = new MMatrix();
    $this.nbo_1 = -1;
    $this.obo_1 = null;
    $this.pbo_1 = new Entry();
    $this.qbo_1 = new FontMetrics();
    $this.rbo_1 = new TextMetrics();
    $this.sbo_1 = null;
    $this.tbo_1 = null;
    $this.ubo_1 = null;
    $this.vbo_1 = null;
    $this.wbo_1 = new MMatrix();
    $this.xbo_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.ybo_1 = true;
    $this.zbo_1 = null;
    $this.abp_1 = fontSource$factory($this);
    return $this;
  }
  hbp(value) {
    if (!(this.tbn_1 === value)) {
      this.tbn_1 = value;
      updateLineCount(this);
      this.uaa();
      this.qaa();
    }
  }
  p1m() {
    return this.tbn_1;
  }
  o53() {
    var tmp = this.ubn_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.i4d_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().m3x_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  fbp(value) {
    if (!equals(this.wbn_1, value)) {
      this.wbn_1 = value;
      this.uaa();
    }
  }
  ibp(value) {
    if (!(this.xbn_1 === value)) {
      this.xbn_1 = value;
      this.uaa();
    }
  }
  y5o(_set____db54di) {
    var this_0 = this.ybn_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  s4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ybn_1;
    fontSize$factory_0();
    return this_0.get();
  }
  uaa() {
    this.rbn_1 = this.rbn_1 + 1 | 0;
    super.uaa();
  }
  b5p() {
    return this.cbo_1.k4n_1;
  }
  m5l() {
    return this.cbo_1.l4n_1;
  }
  ebp(value) {
    this.ibo_1 = value;
    this.fbo_1 = false;
    this.uaa();
  }
  bbp(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  xa7() {
    this.jbp(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.xa7();
    } else {
      return this.jbo_1;
    }
  }
  aa8(ctx) {
    this.jbp(ctx);
    var tva = this.vbo_1;
    if (!(tva == null)) {
      this.mbo_1.t3p(this.p9u());
      this.mbo_1.u3p(this.dbo_1.z68(), this.dbo_1.a69());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.h7y_1;
      var this_1 = this_0.q7y_1;
      if (!(this_1.l7y_1 === this_0)) {
        this_1.l7y_1 = this_0;
        this_1.v7z();
      }
      var tmp = this.wbn_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.x4e();
      this_0.c86(tex, this.obn_1, this.iad(), get_agProgram(bmpfont), tva.t85_1, tva.s85_1);
      this_0.x85(tva, this.mbo_1.r3p());
    } else {
      super.aa8(ctx);
    }
  }
  jbp(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.ibo_1;
      if (!this.fbo_1 && !(fontSource == null)) {
        this.fbo_1 = true;
        launchImmediately_0(ctx.n7x_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.wbn_1.c1k();
    var tmp;
    var tmp_0;
    if (this.kbo_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.lbo_1 === this.rbn_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.lbo_1 = this.rbn_1;
      var metrics = getTextBounds(font, this.xbn_1, this.p1m(), this.rbo_1, this.bbo_1, this.cbo_1);
      this.jbo_1 = new Rectangle(metrics.t26(), VerticalAlign__getOffsetY_impl_iso0y6(this.cbo_1.l4n_1, metrics.x2i(), -metrics.s4n()), metrics.w2i(), font.b4f(this.xbn_1, this.qbo_1).t4e() * this.sbn_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.bbo_1.f5k();
        if (!(this.tbo_1 === this.obn_1) || !(this.pbn_1 === this.rbn_1) || !(this.qbn_1 === rversion)) {
          this.tbo_1 = this.obn_1;
          this.qbn_1 = rversion;
          this.pbn_1 = this.rbn_1;
          if (!(this.zbo_1 == null)) {
            this.zbo_1 = null;
            this.dbo_1.cab();
          }
          this.ebo_1.q5l();
          this.ebo_1.d5l_1 = Companion_getInstance_3().w4l_1;
          invoke(this.bbo_1, this.ebo_1, this.p1m(), this.xbn_1, font);
          while (this.dbo_1.waa() < this.ebo_1.d1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.dbo_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_25().d25_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.jbf(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.dbo_1.waa() > this.ebo_1.d1()) {
            this.dbo_1.f1(this.dbo_1.waa() - 1 | 0).wad();
          }
          var bounds = this.ebo_1.s3a();
          var firstBounds = this.ebo_1.o5l(0);
          var lineInfos = this.ebo_1.n5l();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.m5k_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.o26_1;
          var textHeight = bounds.p26_1;
          var dx = this.kbo_1 ? this.jbo_1.m26_1 : this.jbo_1.m26_1 + 1 + (this.jbo_1.o26_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.b5p());
          var tmp_2;
          if (this.kbo_1) {
            tmp_2 = this.jbo_1.n26_1 + firstLineInfos.k5k_1;
          } else {
            var tmp2_subject = this.m5l();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().t5j_1) ? this.jbo_1.n26_1 : this.jbo_1.n26_1 + firstLineInfos.k5k_1 + (this.jbo_1.p26_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.m5l());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.ebo_1.d1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.ebo_1.p5l(n, this.pbo_1);
              var tmp_3 = this.dbo_1.f1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.kar_1 = program;
              it.y4c(this.o53());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.q25(numberToDouble(0), numberToDouble(0)));
              it.gar_1 = this.obn_1;
              it.dap(entry.n5k_1);
              it.d4q(Vector2D.l28(entry.o5k_1 + dx, entry.p5k_1 + dy));
              it.lac(Scale.z2d(entry.q5k_1, entry.r5k_1));
              it.rbf(entry.s5k_1);
              var containsLower = this.zbn_1;
              it.h8g(n < this.abo_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.tbo_1 === this.obn_1) || !(this.ubo_1 === this.ybo_1)) {
          this.rbn_1 = this.rbn_1 + 1 | 0;
          this.ubo_1 = this.ybo_1;
          this.sbo_1 = this.gbo_1;
          this.tbo_1 = this.obn_1;
        }
        if (!(this.pbn_1 === this.rbn_1)) {
          this.pbn_1 = this.rbn_1;
          var realTextSize = this.xbn_1;
          if (this.zbo_1 == null) {
            this.dbo_1.cab();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.dbo_1;
            var renderer = this.xbo_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.nbc(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).u4k();
            this_3.lbc(tmp$ret$10);
            this_3.tbc();
            tmp_4.zbo_1 = this_3;
            var tmp3_safe_receiver = this.zbo_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.rbc(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.zbo_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.p1m();
          var tmp1_pos = Companion_getInstance_27().e26_1;
          var tmp2_paint = this.o53();
          var tmp3_renderer = this.bbo_1;
          var tmp4_align = this.cbo_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.ubn_1;
          var tmp7_stroke = this.vbn_1;
          var tmp8_textRangeStart = this.zbn_1;
          var tmp9_textRangeEnd = this.abo_1;
          result_0 = this_5.p5p(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.u4k();
          this_4.lbc(tmp$ret$16);
          var metrics_0 = result_0;
          this.nbo_1 = this.rbn_1;
          this.obo_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_27().e26_1, font.b4f(this.s4e(), this.qbo_1).f4f_1);
        }
        var tmp4_safe_receiver = this.zbo_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.qbc(this.obn_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_8 {
  kbp(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n24();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n24();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.pad(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.tbp_1 = $view;
    this.ubp_1 = $ctx;
    this.vbp_1 = this$0;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.fbf_1 = true;
    this.gbf_1 = null;
  }
  obf(_set____db54di) {
    this.fbf_1 = _set____db54di;
  }
  pbf(value) {
    this.fbf_1 = false;
    this.gbf_1 = value;
  }
  ebf(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.pbf(sourceFile);
    _this__u8e3s4.obf(true);
  }
  mbf(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  lbf(ctx, view) {
    if (this.fbf_1)
      return Unit_instance;
    this.wbp(ctx, view);
  }
  wbp(ctx, view) {
    if (!this.fbf_1 && !(this.gbf_1 == null)) {
      this.fbf_1 = true;
      launchImmediately_0(ctx.n7x_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.xbp_1 = this$0;
  }
  od($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static g9o(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().n84_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.w64();
    $this.g9g_1 = new Mixin();
    $this.h9g_1 = coroutineContext;
    $this.i9g_1 = ag;
    $this.j9g_1 = injector;
    $this.k9g_1 = input;
    $this.l9g_1 = timeProvider;
    $this.m9g_1 = stats;
    $this.n9g_1 = gameWindow;
    $this.o9g_1 = gameId;
    $this.p9g_1 = settingsFolder;
    $this.q9g_1 = batchMaxQuads;
    $this.r9g_1 = bp;
    $this.s9g_1 = stageBuilder;
    $this.t9g_1 = quality$factory($this.n9g_1);
    $this.u9g_1 = $this;
    $this.v9g_1 = false;
    $this.w9g_1 = continuousRenderMode$factory($this.n9g_1);
    $this.x9g_1 = new ReshapeEvent(0, 0);
    $this.y9g_1 = new UpdateEvent();
    $this.z9g_1 = new ViewsUpdateEvent($this);
    $this.a9h_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.b9h_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.d9h_1 = null;
    $this.e9h_1 = get_resourcesVfs();
    $this.f9h_1 = get_RegisteredImageFormats();
    $this.g9h_1 = new RenderContext($this.i9g_1, $this, $this.n9g_1, $this.m9g_1, $this.h9g_1, $this.q9g_1, $this.n9g_1);
    $this.h9h_1 = true;
    $this.i9h_1 = Colors_getInstance().n3x_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.j9h_1 = HashMap.f8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.k9h_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.l9h_1 = new Resources($this.h9g_1, $this.e9h_1);
    $this.m9h_1 = false;
    $this.n9h_1 = 1280;
    $this.o9h_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.p9h_1 = ArrayList.i1();
    $this.q9h_1 = Companion_getInstance_24().n2g_1;
    $this.r9h_1 = Companion_getInstance_25().h25_1;
    $this.s9h_1 = true;
    $this.t9h_1 = $this.s9g_1($this);
    $this.u9h_1 = $this.t9h_1;
    $this.v9h_1 = true;
    $this.w9h_1 = false;
    $this.x9h_1 = debugExtraFontScale$factory($this.g9h_1);
    $this.y9h_1 = debugExtraFontColor$factory($this.g9h_1);
    $this.z9h_1 = FastArrayList.r1j();
    $this.a9i_1 = $this.l9g_1.n1v();
    var tmp_4 = $this;
    tmp_4.b9i_1 = Pool.l2p(VOID, Views$tempViewsPool$lambda);
    $this.c9i_1 = SizeInt.e2h();
    $this.d9i_1 = SizeInt.e2h();
    $this.e9i_1 = SizeInt.e2h();
    $this.f9i_1 = new Signal();
    $this.g9i_1 = new Signal();
    $this.h9i_1 = -1.0;
    $this.j9g_1.d62(getKClass(CoroutineContext), $this.h9g_1);
    $this.j9g_1.d62(getKClass(AG), $this.i9g_1);
    $this.j9g_1.d62(getKClass(Views), $this);
    $this.g9i_1.y1w(Views$lambda($this));
    $this.f9i_1.y1w(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.i9i_1 = Companion_instance_11.xh('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.j9i_1 = new EventResult();
    $this.k9i_1 = new Signal();
    $this.l9i_1 = Companion_getInstance_0().c1h('debugHightlightView');
    $this.m9i_1 = new Signal();
    $this.n9i_1 = new Signal();
    $this.o9i_1 = ArrayList.i1();
    $this.p9i_1 = updatedSinceFrame$factory($this.n9g_1);
    return $this;
  }
  ds() {
    return this.h9g_1;
  }
  j9r() {
    return this.u9g_1;
  }
  r9o(_set____db54di) {
    var this_0 = this.w9g_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  l9o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w9g_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  zbp() {
    return replace(replace(replace(this.o9g_1, '\\', ''), '/', ''), '..', '');
  }
  q9u() {
    var tmp = this.c9h_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  w23($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  q9o() {
    return this.l9h_1;
  }
  s9o() {
    return this.i9g_1.v6d().o6d_1;
  }
  t9o() {
    return this.i9g_1.v6d().p6d_1;
  }
  abq(value) {
    this.n9h_1 = numberToInt(value);
  }
  bbq() {
    return this.n9h_1;
  }
  cbq(value) {
    this.o9h_1 = numberToInt(value);
  }
  dbq() {
    return this.o9h_1;
  }
  cbl(value) {
    this.abq(value.h27_1);
    this.cbq(value.i27_1);
  }
  bbl() {
    return Size2D.s2e(this.bbq(), this.dbq());
  }
  y5() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  ybp($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  k9r() {
    return this.t9h_1.o81();
  }
  h9o(_set____db54di) {
    var this_0 = this.x9h_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ebq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x9h_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  i9o(_set____db54di) {
    var this_0 = this.y9h_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  fbq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y9h_1;
    debugFontColor$factory_0();
    return this_0.get().i4d_1;
  }
  nb6(block) {
    this.z9h_1.h(block);
  }
  a65(type, event, result, up, down) {
    event.t65(false);
    var result_0 = super.a65(type, event, result, up, down);
    var e = event;
    e.s65(this.u9g_1);
    if (e instanceof KeyEvent) {
      this.k9g_1.v81(e);
      this.k9g_1.c81_1.m80(e);
      if (e.o66_1.equals(Type_UP_getInstance_0()) && this.v9h_1 && (e.q66_1.equals(Key_F12_getInstance()) || e.q66_1.equals(Key_F7_getInstance()))) {
        this.w9h_1 = !this.w9h_1;
        this.n9g_1.l8g(this.w9h_1);
        this.saa(this.t9h_1);
      }
    }
    try {
      return this.t9h_1.j65(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  gbq(frameBuffer) {
    this.g9h_1.m7y_1 = frameBuffer;
    if (this.h9h_1) {
      var tmp0_$this = this.g9h_1;
      var tmp1_color = this.i9h_1;
      tmp0_$this.l88(tmp1_color, 1.0, 0, true, true, true);
    }
    this.f9i_1.z1w(this.g9h_1);
    this.g9h_1.v7z();
    this.t9h_1.wa7(this.g9h_1);
    this.g9h_1.v7z();
    this.t9h_1.fab(this.g9h_1);
    if (this.w9h_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.z9h_1.p1j_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.g9h_1);
      }
    }
    this.g9i_1.z1w(this.g9h_1);
    this.g9h_1.v7z();
  }
  hbq(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.i9g_1.v6d() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.gbq(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.gbq.call(this, frameBuffer);
    }
    return tmp;
  }
  ibq() {
    this.i9g_1.z6d();
    this.hbq();
  }
  m9o(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.l9g_1.n1v();
    this.u9g_1.m9g_1.z6d();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.a9i_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.u9g_1.k9h_1) > 0 ? this.u9g_1.k9h_1 : delta;
    this.a9i_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.t1v())) {
        this.kbq(fixedSizeStep);
      } else {
        this.jbq(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.lbq() > 0);
    if (doRender2) {
      if (this.i9i_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().p1v().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.lbq() + ']');
      }
      this.ibq();
      this.z6d();
    }
  }
  jbq(elapsed) {
    return this.kbq(get_fast(elapsed));
  }
  kbq(elapsed) {
    this.k9g_1.t81(elapsed);
    this.j9i_1.d2q();
    updateSingleViewWithViewsAll(this.t9h_1, this, elapsed);
    this.k9g_1.u81(elapsed);
  }
  k9o() {
  }
  p9o(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.d9i_1 = SizeInt.d2h(actualWidth, actualHeight);
    this.mbq();
  }
  mbq() {
    setBoundsInfo(this.r9g_1, Size2D.j27(this.n9h_1, this.o9h_1), toFloat(this.d9i_1), this.q9h_1, this.r9h_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.g9h_1.t7x_1 = this.r9g_1.y86();
    this.g9h_1.u7x_1 = this.r9g_1.u86();
    // Inline function 'kotlin.also' call
    var this_0 = this.x9g_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.i66_1 = this.d9i_1.b2h_1;
    this_0.j66_1 = this.d9i_1.c2h_1;
    this.j65(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.a9h_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.qbq_1 = this.c9i_1;
    this.j65(this_1);
    this.t9h_1.uaa();
  }
  rbq(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.n9g_1.m8g())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.l9i_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.k9i_1.z1w(viewToHightlight);
  }
  o9u(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.rbq(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.rbq.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  sbq(_set____db54di) {
    var this_0 = this.p9i_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  lbq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p9i_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  z6d() {
    this.n9g_1.z6d();
  }
  saa(view) {
    this.n9g_1.a8h();
  }
  y1i(value) {
    this.g9g_1.y1i(value);
  }
  z1i() {
    return this.g9g_1.z1i();
  }
  e87(pos) {
    return this.r9g_1.e87(pos);
  }
  t86(value) {
    this.r9g_1.t86(value);
  }
  u86() {
    return this.r9g_1.u86();
  }
  v86(value) {
    this.r9g_1.v86(value);
  }
  w86() {
    return this.r9g_1.w86();
  }
  x86(value) {
    this.r9g_1.x86(value);
  }
  y86() {
    return this.r9g_1.y86();
  }
  z86(value) {
    this.r9g_1.z86(value);
  }
  a87() {
    return this.r9g_1.a87();
  }
  b87(value) {
    this.r9g_1.b87(value);
  }
  c87() {
    return this.r9g_1.c87();
  }
  d87() {
    return this.r9g_1.d87();
  }
  v88() {
    return this.n9g_1.v88();
  }
  w88() {
    return this.n9g_1.w88();
  }
  x88() {
    return this.n9g_1.x88();
  }
  g88() {
    return this.n9g_1.g88();
  }
}
class Companion_9 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.s1v() : fastDelta;
    super();
    this.qbp_1 = views;
    this.rbp_1 = fastDelta;
  }
  sbp() {
    return toDuration_0(this.rbp_1);
  }
  g2a() {
    return Companion_instance_24;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.rbp_1) + ')';
  }
}
class Companion_10 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.d2h(0, 0) : size;
    super();
    this.pbq_1 = views;
    this.qbq_1 = size;
  }
  g2a() {
    return Companion_instance_25;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.qbq_1.toString() + ')';
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.tbq_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  ubq(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.tbq_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_32().d29_1;
}
class RenderToTextureResult {
  constructor() {
    this.ybq_1 = null;
    this.zbq_1 = 0;
    this.abr_1 = 0;
    this.bbr_1 = 0;
    this.cbr_1 = 0;
    this.dbr_1 = 1.0;
    this.ebr_1 = Companion_getInstance_30().n29_1;
    this.fbr_1 = null;
    this.gbr_1 = null;
    this.hbr_1 = null;
    this.ibr_1 = null;
  }
  ov() {
    if (this.gbr_1 == null || this.ibr_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.gbr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.ibr_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.r88(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.ybq_1 = null;
    this.fbr_1 = null;
    this.gbr_1 = null;
    this.ibr_1 = null;
    this.hbr_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_49();
    this.jbr_1 = smoothing;
  }
  xbq(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.h7y_1;
    var this_1 = this_0.q7y_1;
    if (!(this_1.l7y_1 === this_0)) {
      this_1.l7y_1 = this_0;
      this_1.v7z();
    }
    this_0.x7z(texture, VOID, VOID, VOID, VOID, matrix, this.jbr_1, renderColorMul, blendMode, Companion_getInstance_6().u84_1);
  }
}
class Companion_12 extends IdentityFilter {
  constructor() {
    Companion_instance_27 = null;
    super(true);
    Companion_instance_27 = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class ViewRenderPhaseFilter {}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.wbs_1 = bounds;
    this.xbs_1 = vertexCount;
    this.ybs_1 = vertexStart;
    this.zbs_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static kbc(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.lb6();
    $this.lbb_1 = autoScaling;
    $this.mbb_1 = true;
    $this.nbb_1 = true;
    $this.obb_1 = true;
    $this.pbb_1 = new GpuShapeViewCommands();
    $this.qbb_1 = 1000;
    $this.rbb_1 = 1000;
    $this.sbb_1 = Companion_getInstance_25().d25_1;
    $this.tbb_1 = true;
    $this.ubb_1 = false;
    $this.vbb_1 = antialiased;
    $this.wbb_1 = shape;
    $this.xbb_1 = false;
    $this.ybb_1 = false;
    $this.zbb_1 = false;
    $this.abc_1 = 0;
    $this.bbc_1 = Companion_getInstance_28().q29();
    $this.cbc_1 = Companion_getInstance_28().q29();
    $this.dbc_1 = false;
    $this.ebc_1 = 1.0;
    $this.fbc_1 = NaN;
    $this.gbc_1 = Companion_getInstance_30().q29();
    $this.hbc_1 = 100000;
    $this.ibc_1 = false;
    $this.jbc_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  par(value) {
    this.obb_1 = value;
    this.lad();
  }
  iaj(value) {
    this.sbb_1 = value;
    this.uaa();
  }
  mar() {
    return this.sbb_1;
  }
  mbc(value) {
    this.vbb_1 = value;
    invalidateShape(this);
  }
  lbc(value) {
    this.wbb_1 = value;
    invalidateShape(this);
  }
  pab() {
    return _get_shapeBounds__actvvf(this).o26_1 * this.mar().m25_1;
  }
  qab() {
    return _get_shapeBounds__actvvf(this).p26_1 * this.mar().n25_1;
  }
  uaa() {
    super.uaa();
    invalidateShape(this);
  }
  xa7() {
    return new Rectangle(_get_shapeBounds__actvvf(this).m26_1 - this.pab(), _get_shapeBounds__actvvf(this).n26_1 - this.qab(), _get_shapeBounds__actvvf(this).o26_1, _get_shapeBounds__actvvf(this).p26_1);
  }
  bbt(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.h5r_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.bbt(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.bbt(_this__u8e3s4.k5s());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.f5r();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  aa8(ctx) {
    this.ebc_1 = this.p9u().d2b().b2c() * ctx.k7x_1.d87();
    if (!(this.fbc_1 === this.ebc_1)) {
      invalidateShape(this);
    }
    ctx.v7z();
    var doRequireTexture = this.bbt(this.wbb_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.aj();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.j7x_1.v6d();
      this.qbb_1 = currentFrameBuffer.o6d_1;
      this.rbb_1 = currentFrameBuffer.p6d_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.qbb_1;
      var height = this.rbb_1;
      ctx.v7z();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.q88(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.s88(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.h7y_1;
          var this_1 = this_0.q7y_1;
          if (!(this_1.l7y_1 === this_0)) {
            this_1.l7y_1 = this_0;
            this_1.v7z();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.l6o(0, 0, rb.o6d_1, rb.p6d_1);
            var temp = this_0.o7z_1;
            this_0.y85();
            this_0.o7z_1 = scissor;
            try {
              if (true) {
                ctx.l88(Colors_getInstance().r3x_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.y85();
              this_0.o7z_1 = temp;
            }
          }
        }finally {
          ctx.t88();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).a3i(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.h7y_1;
        var this_3 = this_2.q7y_1;
        if (!(this_3.l7y_1 === this_2)) {
          this_3.l7y_1 = this_2;
          this_3.v7z();
        }
        this_2.x7z(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.k7x_1.u86()));
        ctx.v7z();
      }finally {
        ctx.r88(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.cbt_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.cbt_1.toString() + ')';
  }
  hashCode() {
    return this.cbt_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.cbt_1.equals(tmp0_other_with_cast.cbt_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.dbt_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.dbt_1 + ')';
  }
  hashCode() {
    return this.dbt_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.dbt_1 === tmp0_other_with_cast.dbt_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_16().f6n_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_22().y6e_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().v6e_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().t6e_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().j6f_1 : cullFace;
    this.ebt_1 = drawType;
    this.fbt_1 = vertexIndex;
    this.gbt_1 = vertexEnd;
    this.hbt_1 = paintShader;
    this.ibt_1 = program;
    this.jbt_1 = colorMask;
    this.kbt_1 = stencilOpFunc;
    this.lbt_1 = stencilRef;
    this.mbt_1 = blendMode;
    this.nbt_1 = cullFace;
  }
  g85() {
    return this.gbt_1 - this.fbt_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.ebt_1) + ', vertexIndex=' + this.fbt_1 + ', vertexEnd=' + this.gbt_1 + ', paintShader=' + toString_0(this.hbt_1) + ', program=' + toString_0(this.ibt_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.jbt_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.kbt_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.lbt_1) + ', blendMode=' + toString_0(this.mbt_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.nbt_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.ebt_1);
    result = imul(result, 31) + this.fbt_1 | 0;
    result = imul(result, 31) + this.gbt_1 | 0;
    result = imul(result, 31) + (this.hbt_1 == null ? 0 : this.hbt_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ibt_1 == null ? 0 : this.ibt_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.jbt_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.kbt_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.lbt_1) | 0;
    result = imul(result, 31) + (this.mbt_1 == null ? 0 : this.mbt_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.nbt_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.ebt_1 === tmp0_other_with_cast.ebt_1))
      return false;
    if (!(this.fbt_1 === tmp0_other_with_cast.fbt_1))
      return false;
    if (!(this.gbt_1 === tmp0_other_with_cast.gbt_1))
      return false;
    if (!equals(this.hbt_1, tmp0_other_with_cast.hbt_1))
      return false;
    if (!equals(this.ibt_1, tmp0_other_with_cast.ibt_1))
      return false;
    if (!(this.jbt_1 === tmp0_other_with_cast.jbt_1))
      return false;
    if (!(this.kbt_1 === tmp0_other_with_cast.kbt_1))
      return false;
    if (!equals(this.lbt_1, tmp0_other_with_cast.lbt_1))
      return false;
    if (!equals(this.mbt_1, tmp0_other_with_cast.mbt_1))
      return false;
    if (!(this.nbt_1 === tmp0_other_with_cast.nbt_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.mbr_1 = 0;
    this.nbr_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.obr_1 = ArrayList.i1();
    this.pbr_1 = null;
    this.qbr_1 = FastArrayList.r1j();
    this.rbr_1 = 0;
    this.sbr_1 = 0;
    this.tbr_1 = MatrixTransform.z2b();
    this.ubr_1 = FastArrayList.r1j();
    this.vbr_1 = AGTextureUnits.g6h();
  }
  y2() {
    this.mbr_1 = 0;
    this.nbr_1.y2();
    this.obr_1.y2();
  }
  abs(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.rbr_1;
      this.rbr_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.nbr_1.p2j(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.mbr_1;
    this.mbr_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  zbr() {
    this.sbr_1 = this.mbr_1;
    return this.sbr_1;
  }
  bbs() {
    return this.mbr_1;
  }
  abt(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.obr_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  vbs(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_22().y6e_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().v6e_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().t6e_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().o7w_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().j6f_1 : cullFace;
    startIndex = startIndex === VOID ? this.sbr_1 : startIndex;
    endIndex = endIndex === VOID ? this.mbr_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.abt(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.abt.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  r73(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.obr_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  wbr(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.r73(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.r73.call(this, i);
    }
    return tmp;
  }
  xbr(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.obr_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  x6d() {
    var tmp0_safe_receiver = this.pbr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.qbr_1.h(tmp0_safe_receiver);
    }
    this.pbr_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.nbr_1.u2j())));
  }
  ybr(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.pbr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.d7y_1.k84(this.qbr_1);
    this.qbr_1.y2();
    ctx.v7z();
    var ag = ctx.j7x_1;
    var vao = AGVertexArrayObject.q6m(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().lbs_1, ctx.h84(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.h7y_1;
    var this_1 = this_0.q7y_1;
    if (!(this_1.l7y_1 === this_0)) {
      this_1.l7y_1 = this_0;
      this_1.v7z();
    }
    this_0.h86();
    var tempMat = (doRequireTexture ? Companion_getInstance_30().n29_1 : this_0.e85()).b2b(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.q7y_1;
    this_2.v7z();
    var temp4 = this_2.w7x_1;
    var temp2d = this_2.x7x_1;
    this_2.x7x_1 = tempMat;
    this_2.w7x_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.x6k(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.m6m();
      this_3.d79(_unary__edvuaz + 1 | 0);
      this_3.e79(this_3.m6m() + 1 | 0);
      var blockSize = this_3.q6k_1;
      var index0 = imul(this_3.m6m() - 1 | 0, blockSize);
      var index1 = imul(this_3.m6m(), blockSize);
      var texBlockSize = this_3.n6k_1.m6s().d1();
      var texIndex0 = imul(this_3.m6m() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.m6m(), texBlockSize);
      if (this_3.m6m() > 0) {
        arraycopy(this_3.s6k_1, index0, this_3.s6k_1, index1, blockSize);
      } else {
        arrayfill(this_3.s6k_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.n6k_1;
      this_3.t6k_1.n79($this$push.l6s(), this_2.w7x_1);
      if (true && this_3.m6m() >= 1) {
        var equals = arrayequal(this_3.s6k_1, index0, this_3.s6k_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.m6m();
          this_3.d79(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.tbr_1 = globalMatrix.d2b();
      var program = GpuShapeViewPrograms_getInstance().sbs_1;
      var scissor = Companion_getInstance_14().h6f_1;
      var this_4 = this.obr_1;
      var n = 0;
      while (n < this_4.d1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.f1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.cbt_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.dbt_1;
            ctx.l88(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.hbt_1;
              this_0.n86(cmd.g85());
              var pixelScale = this.tbr_1.b2c() / ctx.k7x_1.d87();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.q7y_1.x6k(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.m6m();
                  this_5.d79(_unary__edvuaz_2 + 1 | 0);
                  this_5.e79(this_5.m6m() + 1 | 0);
                  var blockSize_0 = this_5.q6k_1;
                  var index0_0 = imul(this_5.m6m() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.m6m(), blockSize_0);
                  var texBlockSize_0 = this_5.n6k_1.m6s().d1();
                  var texIndex0_0 = imul(this_5.m6m() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.m6m(), texBlockSize_0);
                  if (this_5.m6m() > 0) {
                    arraycopy(this_5.s6k_1, index0_0, this_5.s6k_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.s6k_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.n6k_1;
                  var it = this_5.t6k_1;
                  it.h79(paintShader.obt_1);
                  it.i79($this$push_0.dbu(), pixelScale);
                  it.k79($this$push_0.ebu(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.m6m() >= 1) {
                    var equals_0 = arrayequal(this_5.s6k_1, index0_0, this_5.s6k_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.m6m();
                      this_5.d79(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.pbt_1 == null)) {
                  var tex = ctx.z7x_1.n2p();
                  tex.e6j(paintShader.pbt_1);
                  this.vbr_1.x6h(DefaultShaders_getInstance().f6v(), tex);
                  this.ubr_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.ibt_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.m7y_1.h6d_1;
              var tmp5_frameBufferInfo = ctx.m7y_1.n6f();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.c88(_program);
              var tmp8_textureUnits = this.vbr_1.u1i();
              var tmp9_stencilOpFunc = cmd.kbt_1;
              var tmp10_stencilRef = cmd.lbt_1;
              var tmp11_colorMask = cmd.jbt_1;
              var tmp3_elvis_lhs = cmd.mbt_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().o7w_1 : tmp3_elvis_lhs).y7z_1;
              var tmp13_cullFace = cmd.nbt_1;
              var tmp14_drawType = cmd.ebt_1;
              var tmp15_drawOffset = cmd.fbt_1;
              var tmp16_vertexCount = cmd.g85();
              draw(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.v7z();
      this_2.w7x_1 = temp4;
      this_2.x7x_1 = temp2d;
      this_2.x6k(ProjViewUB_getInstance()).f79();
    }
    var _iterator__ex2g4s = this.ubr_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.z7x_1.o2p(tex_0);
    }
    this.ubr_1.y2();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.vbt_1 = this.r6s().j6s(this, u_ProgramType$factory());
    this.wbt_1 = this.t6s().j6s(this, u_Color$factory());
    this.xbt_1 = this.t6s().j6s(this, u_ColorMul$factory());
    this.ybt_1 = this.r6s().j6s(this, u_GlobalAlpha$factory());
    this.zbt_1 = this.r6s().j6s(this, u_GlobalPixelScale$factory());
    this.abu_1 = this.z6r().j6s(this, u_Transform$factory());
    this.bbu_1 = this.t6s().j6s(this, u_Gradientp0$factory());
    this.cbu_1 = this.t6s().j6s(this, u_Gradientp1$factory());
  }
  fbu() {
    return this.vbt_1.yn(this, u_ProgramType$factory_0());
  }
  gbu() {
    return this.wbt_1.yn(this, u_Color$factory_0());
  }
  ebu() {
    return this.xbt_1.yn(this, u_ColorMul$factory_0());
  }
  hbu() {
    return this.ybt_1.yn(this, u_GlobalAlpha$factory_0());
  }
  dbu() {
    return this.zbt_1.yn(this, u_GlobalPixelScale$factory_0());
  }
  ibu() {
    return this.abu_1.yn(this, u_Transform$factory_0());
  }
  jbu() {
    return this.bbu_1.yn(this, u_Gradientp0$factory_0());
  }
  kbu() {
    return this.cbu_1.yn(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().sbs_1 : program;
    this.obt_1 = uniforms;
    this.pbt_1 = texture;
    this.qbt_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.obt_1.toString() + ', texture=' + toString_0(this.pbt_1) + ', program=' + this.qbt_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.obt_1);
    result = imul(result, 31) + (this.pbt_1 == null ? 0 : hashCode(this.pbt_1)) | 0;
    result = imul(result, 31) + this.qbt_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.obt_1, tmp0_other_with_cast.obt_1))
      return false;
    if (!equals(this.pbt_1, tmp0_other_with_cast.pbt_1))
      return false;
    if (!this.qbt_1.equals(tmp0_other_with_cast.qbt_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.cbs_1 = Attribute.p6t('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.dbs_1 = Attribute.p6t('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.ebs_1 = Varying.b6u('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.fbs_1 = Varying.b6u('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.gbs_1 = ProgramLayout.a6n([DefaultShaders_getInstance().k6q_1]);
    this.hbs_1 = ProgramLayout.a6n([DefaultShaders_getInstance().l6q_1]);
    this.ibs_1 = ProgramLayout.a6n([this.dbs_1]);
    this.jbs_1 = ProgramLayout.a6n([DefaultShaders_getInstance().k6q_1, DefaultShaders_getInstance().l6q_1]);
    this.kbs_1 = ProgramLayout.a6n([DefaultShaders_getInstance().k6q_1, this.dbs_1]);
    this.lbs_1 = ProgramLayout.a6n([DefaultShaders_getInstance().k6q_1, this.dbs_1, this.cbs_1]);
    this.mbs_1 = 0;
    this.nbs_1 = 1;
    this.obs_1 = 2;
    this.pbs_1 = 3;
    this.qbs_1 = 4;
    this.rbs_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.q6u();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.v6u(this_0.y6u(), this_0.z6u(this_0.z6u(this_0.k6s(), this_0.l6s()), this_0.c6v([this_0.a6v(), this_0.b6v(0.0), this_0.b6v(1.0)])));
    this_0.v6u(this_0.r6u(), DefaultShaders_getInstance().k6q_1);
    this_0.v6u(GpuShapeViewPrograms_getInstance().fbs_1, GpuShapeViewPrograms_getInstance().dbs_1);
    this_0.v6u(GpuShapeViewPrograms_getInstance().ebs_1, GpuShapeViewPrograms_getInstance().cbs_1);
    var tmp0_vertex = VertexShader(this_0.d6v());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.q6u();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.w6w(GpuShapeViewPrograms_getInstance().fbu(), this_1.b6v(5));
    var body = this_1.m6v();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.v6u(body.y6u(), body.c6v([body.b6v(1.0), body.b6v(0.0), body.b6v(0.0), body.b6v(1.0)]));
    body.f6w();
    var stmIf = new If(cond, body.o6v());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.u6u_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.z6w(this_1.l6w(GpuShapeViewPrograms_getInstance().fbs_1), GpuShapeViewPrograms_getInstance().ebs_1);
    var body_0 = this_1.m6v();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.d6w();
    var stmIf_0 = new If(cond_0, body_0.o6v());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.u6u_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().fbu();
    this_1.c6w(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.u6w(this_1.b6v(1.0), this_1.n6w(this_1.u6w(this_1.z6u(GpuShapeViewPrograms_getInstance().ebs_1, GpuShapeViewPrograms_getInstance().dbu()), this_1.b6v(1.5)), this_1.z6u(GpuShapeViewPrograms_getInstance().ebs_1, GpuShapeViewPrograms_getInstance().dbu()), this_1.l6w(this_1.z6u(GpuShapeViewPrograms_getInstance().fbs_1, GpuShapeViewPrograms_getInstance().dbu()))));
    this_1.v6u(this_1.y6u(), this_1.z6u(this_1.z6u(this_1.z6u(this_1.y6u(), GpuShapeViewPrograms_getInstance().ebu()), GpuShapeViewPrograms_getInstance().hbu()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.d6v());
    tmp.sbs_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.d2q();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.m6m();
      this_2.d79(_unary__edvuaz + 1 | 0);
      this_2.e79(this_2.m6m() + 1 | 0);
      var blockSize = this_2.q6k_1;
      var index0 = imul(this_2.m6m() - 1 | 0, blockSize);
      var index1 = imul(this_2.m6m(), blockSize);
      var texBlockSize = this_2.n6k_1.m6s().d1();
      var texIndex0 = imul(this_2.m6m() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.m6m(), texBlockSize);
      if (this_2.m6m() > 0) {
        arraycopy(this_2.s6k_1, index0, this_2.s6k_1, index1, blockSize);
      } else {
        arrayfill(this_2.s6k_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.n6k_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.t6k_1.j79(ShapeViewUB_getInstance().fbu(), 5);
      if (true && this_2.m6m() >= 1) {
        var equals = arrayequal(this_2.s6k_1, index0, this_2.s6k_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.m6m();
          this_2.d79(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.tbs_1 = new PaintShader(this_2, null);
  }
  fbu() {
    return ShapeViewUB_getInstance().fbu().g6m_1;
  }
  gbu() {
    return ShapeViewUB_getInstance().gbu().g6m_1;
  }
  ebu() {
    return ShapeViewUB_getInstance().ebu().g6m_1;
  }
  hbu() {
    return ShapeViewUB_getInstance().hbu().g6m_1;
  }
  dbu() {
    return ShapeViewUB_getInstance().dbu().g6m_1;
  }
  ibu() {
    return ShapeViewUB_getInstance().ibu().g6m_1;
  }
  jbu() {
    return ShapeViewUB_getInstance().jbu().g6m_1;
  }
  kbu() {
    return ShapeViewUB_getInstance().kbu().g6m_1;
  }
  lbu(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_23().q7f_1;
    return $this$ExpressionBuilder.j6w(_this__u8e3s4, $this$ExpressionBuilder.b6v(2.0));
  }
  ubs(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.d2q();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.m6m();
          this_0.d79(_unary__edvuaz + 1 | 0);
          this_0.e79(this_0.m6m() + 1 | 0);
          var blockSize = this_0.q6k_1;
          var index0 = imul(this_0.m6m() - 1 | 0, blockSize);
          var index1 = imul(this_0.m6m(), blockSize);
          var texBlockSize = this_0.n6k_1.m6s().d1();
          var texIndex0 = imul(this_0.m6m() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.m6m(), texBlockSize);
          if (this_0.m6m() > 0) {
            arraycopy(this_0.s6k_1, index0, this_0.s6k_1, index1, blockSize);
          } else {
            arrayfill(this_0.s6k_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.n6k_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.t6k_1;
          it.j79($this$push.fbu(), 0);
          it.k79($this$push.gbu(), _RGBA___get_premultiplied__impl__3bulqc(paint.i4d_1));
          it.j79($this$push.hbu(), globalAlpha);
          if (true && this_0.m6m() >= 1) {
            var equals = arrayequal(this_0.s6k_1, index0, this_0.s6k_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.m6m();
              this_0.d79(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_30().n29_1.i2b(paint.v5e_1).i2b(stateTransform).c2b().p2a(1.0 / paint.u5e_1.f3w_1, 1.0 / paint.u5e_1.g3w_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.d2q();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.m6m();
            this_1.d79(_unary__edvuaz_1 + 1 | 0);
            this_1.e79(this_1.m6m() + 1 | 0);
            var blockSize_0 = this_1.q6k_1;
            var index0_0 = imul(this_1.m6m() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.m6m(), blockSize_0);
            var texBlockSize_0 = this_1.n6k_1.m6s().d1();
            var texIndex0_0 = imul(this_1.m6m() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.m6m(), texBlockSize_0);
            if (this_1.m6m() > 0) {
              arraycopy(this_1.s6k_1, index0_0, this_1.s6k_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.s6k_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.n6k_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.t6k_1;
            it_0.j79($this$push_0.fbu(), 1);
            it_0.n79($this$push_0.ibu(), toMatrix4(mat));
            it_0.j79($this$push_0.hbu(), globalAlpha);
            if (true && this_1.m6m() >= 1) {
              var equals_0 = arrayequal(this_1.s6k_1, index0_0, this_1.s6k_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.m6m();
                this_1.d79(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.u5e_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.y3v(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.j3w_1;
            if (true) {
              gradientBitmap.s3w();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.g5e(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.v3v_1));
            }finally {
              result = true ? gradientBitmap.u3w(rect) : 0;
            }
            var npaint = paint.h5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_30().n29_1.i2b(paint.c52_1).i2b(stateTransform));
            var mat_0 = paint.s51_1.k3_1 === 0 ? npaint.i52_1 : npaint.c52_1.c2b();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.d2q();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.m6m();
              this_2.d79(_unary__edvuaz_3 + 1 | 0);
              this_2.e79(this_2.m6m() + 1 | 0);
              var blockSize_1 = this_2.q6k_1;
              var index0_1 = imul(this_2.m6m() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.m6m(), blockSize_1);
              var texBlockSize_1 = this_2.n6k_1.m6s().d1();
              var texIndex0_1 = imul(this_2.m6m() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.m6m(), texBlockSize_1);
              if (this_2.m6m() > 0) {
                arraycopy(this_2.s6k_1, index0_1, this_2.s6k_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.s6k_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.n6k_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.t6k_1;
              var tmp_0 = $this$push_1.fbu();
              var tmp0 = paint.s51_1.k3_1;
              it_1.j79(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.n79($this$push_1.ibu(), toMatrix4(mat_0));
              it_1.m79($this$push_1.jbu(), new Vector4F(paint.t51_1, paint.u51_1, paint.v51_1, 1.0));
              it_1.m79($this$push_1.kbu(), new Vector4F(paint.w51_1, paint.x51_1, paint.y51_1, 1.0));
              it_1.j79($this$push_1.hbu(), globalAlpha);
              if (true && this_2.m6m() >= 1) {
                var equals_1 = arrayequal(this_2.s6k_1, index0_1, this_2.s6k_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.m6m();
                  this_2.d79(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.nd('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.z9c($this.o9b_1.y9c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.p9b_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_36() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().l1w($this.v9c_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.c9d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.s9f(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.h1b($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_37() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.q9i_1.t9b_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.r9i_1.t9h_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_26().u2g_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.bl();
    var height = size.cl();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.w2i();
      rwidth = tmp1_elvis_lhs == null ? views_0.t9h_1.w2i() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.x2i();
      rheight = tmp3_elvis_lhs == null ? views_0.t9h_1.x2i() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.u9n(views_0, defaultTransition, name, Size2D.s2e(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).v9n($this.q9i_1.t9b_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.s9i_1($this.r9i_1.t9h_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.q9i_1.b9c_1) {
    var tmp_3 = $this.t9i_1.r8g($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.w9n_1, $this.x9n_1, $this.y9n_1, $this.z9n_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.h1b($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_35().e1f()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().x62();
    try {
      var tmp0_elvis_lhs = $this.c9o_1.j9c_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().n3x_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.a9o_1, $this.b9o_1, $this.c9o_1.i9c_1, null, $this.c9o_1.a9c_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().x62();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.d8g(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().x62();
    try {
      try {
        if (!($this.d9o_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().xh($this.d9o_1), $this.e9o_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.f8g(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_36().a9d_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.k2t(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.l2t(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().x62();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.d8g('setIcon', tmp$ret$5);
    }
  }
  $this$loop.k8g($this$loop.d88());
  if (Companion_getInstance_35().e1f()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.lc();
  var this_3 = Views.g9o(tmp$ret$6.qm(gameWindow.y8f()).qm(new InjectorContext($this.c9o_1.v9b_1)).qm(SupervisorJob()).qm(CoroutineName.yy('Views')), $this.c9o_1.q9c_1 ? AGPrint.j77() : $this$loop.x8f(), $this.c9o_1.v9b_1, input, $this.c9o_1.u9b_1, stats, gameWindow, $this.c9o_1.c9c_1, $this.c9o_1.d9c_1, $this.c9o_1.e9c_1, VOID, $this.c9o_1.t9c_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.w23($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_35().h1f()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.b2x(), 'views', this_3);
  }
  var views = this_3;
  $this.c9o_1.v9b_1.d62(getKClass(GameWindow), gameWindow);
  $this.c9o_1.v9b_1.d62(getKClass(Korge), $this.c9o_1);
  views.w9h_1 = $this$loop.m8g();
  views.h9o($this.c9o_1.r9c_1);
  views.i9o($this.c9o_1.s9c_1);
  views.n9h_1 = numberToInt($this.c9o_1.g9c_1.h27_1);
  views.o9h_1 = numberToInt($this.c9o_1.g9c_1.i27_1);
  views.r9h_1 = $this.c9o_1.h9c_1.a9g_1;
  views.q9h_1 = $this.c9o_1.h9c_1.z9f_1;
  views.s9h_1 = $this.c9o_1.h9c_1.b9g_1;
  views.h9i_1 = $this.c9o_1.u9c_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().x62();
    try {
      KorgeReload_getInstance().m7w(gameWindow);
      var tmp_4 = KorgeRunner_instance.j9o(views, gameWindow, true, $this$loop.j8g(), Companion_instance_1.t1v(), $this.c9o_1.n9c_1, $this.c9o_1.w9b_1).vu($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().x62();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.d8g(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().x62();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().x62();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.d8g(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.c9o_1, views, $this.f9o_1, gameWindow));
  if ($this.c9o_1.b9c_1) {
    var tmp_5 = gameWindow.r8g($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.p8g();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().y35();
      if (get_workerImpl().z35()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().v5a([config.r9b_1]);
      var iconPath = config.l9c_1;
      var imageFormats = config.r9b_1;
      var entry = config.p9c_1;
      var windowSize = config.f9c_1;
      if (!Companion_getInstance_35().h1f()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().xh('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.s9b_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.lc().yc(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.o9c_1.t8h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.i9c_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.j9c_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().n3x_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.i8g(tmp_1);
      var tmp_3 = realGameWindow.s8g(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.e87(Vector2D.l28(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.q81(button, true);
  input.p81(p, false);
  input.p81(p, true);
  $views.k9o();
  downPos._v = input.o81();
  downTime._v = new DateTime(Companion_getInstance_5().n1v());
  input.a81_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.q81(button, false);
  input.p81(p, false);
  $views.k9o();
  upPos._v = $views.k9g_1.o81();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.k9g_1.p81(p, false);
  $views.k9g_1.a81_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.k9o();
  moveTime._v = new DateTime(Companion_getInstance_5().n1v());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.k9g_1.p81(p, false);
  $views.k9o();
  moveTime._v = new DateTime(Companion_getInstance_5().n1v());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.h69_1 = 0;
  mouseTouchEvent.k69_1 = true;
  mouseTouchEvent.i69_1 = Companion_getInstance_5().n1v();
  mouseTouchEvent.j69_1 = false;
  mouseTouchEvent.s69(type);
  mouseTouchEvent.x69(button.y6c_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.t69();
  $views.j65(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.s6a_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.k81_1[gamepad.t6a_1].b6b(gamepad);
  }
  input.r81();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.m9o($fixedSizeStep, $views.l9o(), event.x65_1, event.y65_1);
    $views.k9g_1.z80_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.k9g_1.z80_1 = true;
      $views.k9g_1.a81_1 = false;
      $views.k9o();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_36().a9d_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.k2t(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.l2t(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.v9g_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.n9o($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.h67_1, e.i67_1, e.s67_1);
    var tmp_0;
    switch (e.f67_1.k3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.j67_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.j67_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.j67_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.j67_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.j67_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.j65(e);
    get_nativeSoundProvider().z2q(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.j65(e);
    get_nativeSoundProvider().z2q(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.j65(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.n81(e);
    var ee = $input.s80_1;
    var _iterator__ex2g4s = ee.p69().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.u68_1 = prepareViewsBase$getRealXY($views, t.z68(), t.a69(), e.j69_1);
    }
    $views.j65(ee);
    var tmp_0;
    if (ee.q69() === 1) {
      var start = ee.a6a();
      var end = ee.b6a();
      var t_0 = first(ee.p69());
      var p = t_0.u68_1;
      var x = t_0.z68();
      var y = t_0.a69();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.g67_1 = 0;
      this_1.j67_1 = button;
      this_1.k67_1 = end ? 0 : 1 << button.y6c_1;
      this_1.h67_1 = numberToInt(x);
      this_1.i67_1 = numberToInt(y);
      this_1.s67_1 = false;
      this_1.t67_1 = true;
      this_1.f67_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.j65(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().a9d_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.j65(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.p9o($ag.v6d().o6d_1, $ag.v6d().p6d_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.j65(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.y65_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.g9h_1;
      var frameBuffer = this_0.v6d();
      this_0.q7x_1.d2q();
      this_0.j7x_1.z6d();
      var tmp_0;
      try {
        this_0.s88(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.my(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.t88();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.j7x_1.t69();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_36().b9d_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().n84_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().y81_1.h27_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().y81_1.i27_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.j27(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.h27_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.i27_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.j27(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().n2g_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_25().p25() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().n3x_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().m3x_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).x9f(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.c9d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.s9f(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.c9d(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.a9p_1.y9o_1.k1x($this.b9p_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.c9p_1.w9o_1.k1x($this.d9p_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.e9p_1.x9o_1.k1x($this.f9p_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.q65_1;
    tmp.v9o_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g9p().h9g_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.q65_1;
    tmp.v9o_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g9p().h9g_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.q65_1;
    tmp.v9o_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.g9p().h9g_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function onMouseDrag(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  return onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback).zk_1;
}
function onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  var dragging = {_v: false};
  var sx = {_v: 0.0};
  var sy = {_v: 0.0};
  var cx = {_v: 0.0};
  var cy = {_v: 0.0};
  var view = _this__u8e3s4;
  var mousePos = {_v: Vector2D.w28()};
  var onDownCloseable = null;
  var onUpAnywhereCloseable = null;
  var onMoveAnywhereCloseable = null;
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var $this$mouse = get_mouse(_this__u8e3s4);
  // Inline function 'korlibs.korge.input.MouseEvents.onDownCloseable' call
  var handler = onMouseDragInternal$slambda_2(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp = down$factory().get($this$mouse);
  onDownCloseable = tmp.x1w(onMouseDragInternal$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhereCloseable' call
  var handler_0 = onMouseDragInternal$slambda_3(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_0 = upAnywhere$factory().get($this$mouse);
  onUpAnywhereCloseable = tmp_0.x1w(onMouseDragInternal$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onMoveAnywhereCloseable' call
  var handler_1 = onMouseDragInternal$slambda_4(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_1 = moveAnywhere$factory().get($this$mouse);
  onMoveAnywhereCloseable = tmp_1.x1w(onMouseDragInternal$lambda_1($this$mouse, handler_1));
  var tmp_2;
  if (onDownCloseable == null) {
    throwUninitializedPropertyAccessException('onDownCloseable');
  } else {
    tmp_2 = onDownCloseable;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  if (onUpAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onUpAnywhereCloseable');
  } else {
    tmp_4 = onUpAnywhereCloseable;
  }
  var tmp_5 = tmp_4;
  var tmp_6;
  if (onMoveAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onMoveAnywhereCloseable');
  } else {
    tmp_6 = onMoveAnywhereCloseable;
  }
  return to(_this__u8e3s4, new OnMouseDragCloseable(tmp_3, tmp_5, tmp_6));
}
var MouseDragState_START_instance;
var MouseDragState_DRAG_instance;
var MouseDragState_END_instance;
var MouseDragState_entriesInitialized;
function MouseDragState_initEntries() {
  if (MouseDragState_entriesInitialized)
    return Unit_instance;
  MouseDragState_entriesInitialized = true;
  MouseDragState_START_instance = new MouseDragState('START', 0);
  MouseDragState_DRAG_instance = new MouseDragState('DRAG', 1);
  MouseDragState_END_instance = new MouseDragState('END', 2);
}
function draggableCloseable(_this__u8e3s4, selector, autoMove, onDrag) {
  selector = selector === VOID ? _this__u8e3s4 : selector;
  autoMove = autoMove === VOID ? true : autoMove;
  onDrag = onDrag === VOID ? null : onDrag;
  return draggableInternal(_this__u8e3s4, selector, autoMove, onDrag).al_1;
}
function draggableInternal(_this__u8e3s4, selector, autoMove, onDrag) {
  selector = selector === VOID ? _this__u8e3s4 : selector;
  autoMove = autoMove === VOID ? true : autoMove;
  onDrag = onDrag === VOID ? null : onDrag;
  var view = _this__u8e3s4;
  var info = new DraggableInfo(view);
  var onMouseDragCloseable_0 = onMouseDragCloseable(selector, VOID, info, draggableInternal$lambda(info, view, autoMove, onDrag));
  return to(_this__u8e3s4, new DraggableCloseable(onMouseDragCloseable_0));
}
function onMouseDragCloseable(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  return onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback).al_1;
}
function onMouseDragInternal$views(view) {
  return ensureNotNull(view.i9r()).j9r();
}
function onMouseDragInternal$updateMouse(mousePos, view) {
  var views = onMouseDragInternal$views(view);
  mousePos._v = views.k9r();
}
function onMouseDragInternal$handle(dragging, $info, mousePos, sx, sy, cx, cy, $callback, $timeProvider, view, it, state) {
  if (!state.equals(MouseDragState_START_getInstance()) && !dragging._v)
    return Unit_instance;
  onMouseDragInternal$updateMouse(mousePos, view);
  $info.s9p_1 = it;
  var px = mousePos._v.c26_1;
  var py = mousePos._v.d26_1;
  switch (state.k3_1) {
    case 0:
      dragging._v = true;
      sx._v = px;
      sy._v = py;
      $info.d2q();
      break;
    case 2:
      dragging._v = false;
      break;
    default:
      break;
  }
  cx._v = mousePos._v.c26_1;
  cy._v = mousePos._v.d26_1;
  var dx = cx._v - sx._v;
  var dy = cy._v - sy._v;
  $callback(onMouseDragInternal$views(view), $info.b9q(dx, dy, state.a6a(), state.b6a(), $timeProvider.n1v(), sx._v, sy._v, cx._v, cy._v));
}
function onMouseDragInternal$slambda_2($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.v9r(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = $this.w9r_1($this.x9r_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_2($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda($this, $handler) {
  return function (it) {
    var tmp = $this.n9t();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_3($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_0($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.v9r(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  var tmp = $this.y9t_1($this.z9t_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_3($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_0($handler, $it);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_0($this, $handler) {
  return function (it) {
    var tmp = $this.n9t();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_3($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_4($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  var i = new onMouseDragInternal$slambda_1($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view);
  var l = function (it, $completion) {
    return i.v9r(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = $this.k9u_1($this.l9u_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onMouseDragInternal$lambda$slambda_4($handler, $it) {
  var i = new onMouseDragInternal$lambda$slambda_1($handler, $it);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function onMouseDragInternal$lambda_1($this, $handler) {
  return function (it) {
    var tmp = $this.n9t();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_4($handler, it));
    return Unit_instance;
  };
}
function draggableInternal$lambda($info, $view, $autoMove, $onDrag) {
  return function ($this$onMouseDragCloseable, it) {
    var tmp;
    if ($info.k9p_1) {
      $info.y9q_1 = $view.t1h();
      tmp = Unit_instance;
    }
    $info.z9q_1 = $view.t1h();
    $info.a9r_1 = Vector2D.l28($info.c9r() + $info.z9p($view), $info.d9r() + $info.a9q($view));
    $info.b9r_1 = Vector2D.l28($info.g9r() - $info.e9r(), $info.h9r() - $info.f9r());
    var tmp_0;
    if ($autoMove) {
      xy($view, $info.a9r_1);
      tmp_0 = Unit_instance;
    }
    var tmp0_safe_receiver = $onDrag;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver($info);
    return Unit_instance;
  };
}
function MouseDragState_START_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_START_instance;
}
function MouseDragState_DRAG_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_DRAG_instance;
}
function MouseDragState_END_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_END_instance;
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
function upAnywhere$factory() {
  return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
    return receiver.m9s_1;
  }, null);
}
function moveAnywhere$factory() {
  return getPropertyCallableRef('moveAnywhere', 1, KProperty1, function (receiver) {
    return receiver.o9s_1;
  }, null);
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.k9g_1)) {
    set_mouseHitSearch(views.k9g_1, true);
    set_mouseHitResult(views.k9g_1, views.t9h_1.m9u(views.k9r()));
    var view = get_mouseHitResult(views.k9g_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.n24();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.n9g_1.w8f(), newCursor)) {
      views.n9g_1.v8f(newCursor);
    }
  }
  return get_mouseHitResult(views.k9g_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.f88();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.u86();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_16, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.n9u();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.o9u(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.g9h_1.h7y_1;
      var this_1 = this_0.q7y_1;
      if (!(this_1.l7y_1 === this_0)) {
        this_1.l7y_1 = this_0;
        this_1.v7z();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.w7z(tmp$ret$1);
      var tmp1_x = bounds.m26_1;
      var tmp2_y = bounds.n26_1;
      var tmp3_width = bounds.o26_1;
      var tmp4_height = bounds.p26_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().o3x_1, 0.3);
      var tmp6_m = mouseHit.p9u();
      this_0.x7z(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.g9h_1;
      var tmp8_font = _this__u8e3s4.q9u();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.k9r().c26_1 + ',' + $views.k9r().d26_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.g7y_1;
      var tmp12_blendMode = Companion_getInstance_13().y7w_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.k9g_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.n9u();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.g9h_1.h7y_1;
      var this_3 = this_2.q7y_1;
      if (!(this_3.l7y_1 === this_2)) {
        this_3.l7y_1 = this_2;
        this_3.v7z();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.w7z(tmp$ret$4);
      var tmp1_x_0 = bounds_0.m26_1;
      var tmp2_y_0 = bounds_0.n26_1;
      var tmp3_width_0 = bounds_0.o26_1;
      var tmp4_height_0 = bounds_0.p26_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().w4b(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.p9u();
      this_2.x7z(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.g9h_1;
        var tmp8_font_0 = _this__u8e3s4.q9u();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.g7y_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().y7w_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.n24();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.r9u(views, dt.gj_1);
    return Unit_instance;
  };
}
var Companion_instance_16;
function Companion_getInstance_38() {
  return Companion_instance_16;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.i9t_1;
  var tmp = $this;
  tmp.i9t_1 = lastEventNew == null ? $this.i9t_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.i9t_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.z9r_1.w9u()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.q65_1;
    tmp_0.a9s_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.h9t_1 = event;
    this$0.i9t_1.x67(event);
    this$0.j9t_1 = event.t67_1;
    this$0.g9t_1 = true;
    var tmp_2;
    switch (event.f67_1.k3_1) {
      case 2:
        this$0.k9t_1.x67(event);
        this$0.b9t_1 = this$0.j9r().k9g_1.o81();
        this$0.y9s_1 = PerformanceCounter_getInstance().y62();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.y9s_1, this$0.z9s_1);
        var tmp_3;
        if (this$0.b9t_1.r2h(this$0.a9t_1) < this$0.j9r().k9g_1.v80_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.j9r().k9g_1.u80_1) < 0) {
          var _unary__edvuaz = this$0.f9t_1;
          this$0.f9t_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.x9u()) {
            this$0.c9s_1.z1w(this$0);
            var tmp_5;
            if (this$0.c9s_1.e1x() > 0) {
              event.z67(this$0.z9r_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.q67_1) {
          set_mouseDebugLastFrameClicked(this$0.j9r(), true);
        }

        this$0.z9s_1 = PerformanceCounter_getInstance().y62();
        this$0.a9t_1 = this$0.j9r().k9g_1.o81();
        var tmp_6;
        if (this$0.b9s_1.f1x()) {
          var tmp_7;
          if (this$0.x9u()) {
            this$0.b9s_1.z1w(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.x9u()) {
          this$0.r9s_1.z1w(this$0);
        } else {
          this$0.t9s_1.z1w(this$0);
        }

        this$0.s9s_1.z1w(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.i9s_1.z1w(this$0);
      tmp = Unit_instance;
    } else {
      this$0.j9s_1.z1w(this$0);
      this$0.l9s_1.z1w(this$0);
      tmp = Unit_instance;
    }
    this$0.m9s_1.z1w(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.k7x_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.t9v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.ds(), SceneCancellationException.i9v($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.j9r().h9g_1.qm(new InjectorContext(this$0.u9v())).qm(SupervisorJob(this$0.j9r().h9g_1.yc(Key_instance))).qm(CoroutineName.yy('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.w9v(this$0.v9v().d1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.o9v_1.f9y(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.u9v().m62(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.ds();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.i9y();
  }, null);
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var scene = $this.na1_1.r9n_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.na1_1.r9n_1) + ' . doFullReload=' + $this.oa1_1.va1());
    var tmp;
    if ($this.oa1_1.va1()) {
      tmp = $this.oa1_1.wa1(getKClassFromExpression(scene), scene.u9v());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.na1_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.p9n_1;
    var sceneInjector = this_0.o9n_1.j9g_1.f62().d62(getKClass(SceneContainer), this_0).d62(getKClass(Resources), new Resources(this_0.ds(), this_0.o9n_1.q9o().y33_1, this_0.o9n_1.q9o()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.d62(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.m62(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.oa1_1.g7w(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_39().xa1_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.k2t(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.l2t(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.o62(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.o9n_1.j9g_1.h62(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.oa1_1, scene));
    }
    var tmp_5 = this_0.za1(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.j9r().o9u(scene_0.i9y());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.m62($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.g7w($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.aa2_1.i9y();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.aa2_1.va0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ba2_1.i9y();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ba2_1.wa0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.ca2_1.ya0($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = $this.da2_1.za0($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.da2_1.aa1();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.ea2_1.ba1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.fa2_1.xa0($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.o9n_1.j9g_1.f62().d62(getKClass(SceneContainer), $this).d62(getKClass(Resources), new Resources($this.ds(), $this.o9n_1.q9o().y33_1, $this.o9n_1.q9o()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.d62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.m62(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_39().xa1_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.k2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.l2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.o62(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.o9n_1.j9g_1.h62(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.za1(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.r9n_1;
  $this.r9n_1 = newScene;
  $this.q9n_1.ra4(newScene.o9v_1, transition);
  try {
    var tmp = newScene.ds();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.ds();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.q9n_1);
    var initial = Companion_getInstance_34().m1i_1;
    var end = Companion_getInstance_34().p1i_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.q9n_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.q9n_1.oa4_1 = Companion_getInstance_34().p1i_1;
  }
  $this.q9n_1.sa4();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.ds();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.ds();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_17;
function Companion_getInstance_39() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.r9n_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.m62($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.l1i_1, p1.l1i_1, p2.l1i_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.oa4_1);
  }, function (value) {
    $b0.oa4_1 = value.l1i_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.qa4_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.bad();
  var nextAlpha = next.bad();
  try {
    prev.aad(1.0 - Ratio__toFloat_impl_1ftup5(ratio.l1i_1));
    next.aad(Ratio__toFloat_impl_1ftup5(ratio.l1i_1));
    prev.wa7(ctx);
    next.wa7(ctx);
  }finally {
    prev.aad(prevAlpha);
    next.aad(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.yn(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.e6w($this$FUNC.r7g($this$FUNC.q7g(a, b), $this$FUNC.q7g($this$FUNC.r7g(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.v6u($this$IF_ELSE_BINARY_LOOKUP.y6u(), $this$IF_ELSE_BINARY_LOOKUP.g6v(Companion_getInstance_6().l84_1[n], $this$IF_ELSE_BINARY_LOOKUP.e6v($$this$buildShader.r6u(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.t1v() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.t1v();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.raf(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.t1v() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.kaf_1) {
    $this.daf_1.qaa();
  }
  if ($this.naf_1) {
    return $this.waf();
  }
  $this.laf_1 = FastDuration__plus_impl_q1enab($this.laf_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.laf_1, $this.maf_1), 0.0, 1.0);
  $this.raf($this.laf_1);
  $this.haf_1($this.gaf_1.f1i(ratio));
  var tmp;
  var tmp_0 = $this.xaf();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7($this.laf_1, $this.xaf()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.yaf();
  }
  if (ratio >= 1.0) {
    return $this.waf();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.i8i_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.naf_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.t1v()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.lc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.uw();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.zaf_1;
  $this.aag_1._v = new TweenComponent(view, toList($this.bag_1), $this.cag_1, $this.dag_1, $this.eag_1, cancellable, $this.fag_1, $this.gag_1);
  var tmp$ret$0 = cancellable.gu();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.h1b($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_33());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.oa7_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.i9r();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.oa7_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_40() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.iaj(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.val_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.val_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.f1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.aam_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c7y_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.z83(it, 'BaseGraphics');
      }
    }
  }
  $this.val_1.y2();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.e58().w2i();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.e58().x2i();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.m26_1 - $this.pab(), bounds.n26_1 - $this.qab(), bounds.o26_1, bounds.p26_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.eam_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.zal_1) {
    $this.zal_1 = false;
    $this.gam_1 = $this.pao(false);
    $this.fam_1 = $this.pao(true);
  }
  return strokes ? $this.fam_1 : $this.gam_1;
}
function updateGraphics($this) {
  var halfStroke = $this.xau_1 / 2;
  var radius = $this.vax();
  $this.wax(toShape2D(new Circle(Vector2D.l28(radius, radius), radius)));
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  // Inline function 'korlibs.korge.view.Circle.updateGraphics.<anonymous>' call
  var $this$updatePath = $this.yau_1;
  $this$updatePath.y2();
  $this$updatePath.j38(Vector2D.l28(radius, radius), radius);
  $this$updatePath.n3e_1 = true;
  $this.uau_1 = $this.yau_1;
  $this.xax();
}
function Circle$radius$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics(this$0);
    return Unit_instance;
  };
}
function colorMul$factory($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.a4d());
  }, function (value) {
    return $b0.y4c(value.i4d_1);
  });
}
function radius$factory() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.vax();
  }, function (receiver, value) {
    return receiver.aay(value);
  });
}
function radius$factory_0() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.vax();
  }, function (receiver, value) {
    return receiver.aay(value);
  });
}
function color$factory() {
  return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.o53());
  }, function (receiver, value) {
    return receiver.bay(value.i4d_1);
  });
}
function color$factory_0() {
  return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.o53());
  }, function (receiver, value) {
    return receiver.bay(value.i4d_1);
  });
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.c5r();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.f9y(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.kb6();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.dab(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_41() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().z62())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.j9r().f9i_1;
  tmp.y1w(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.j9r().g9h_1).k87_1;
  tmp_0.y1w(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.j9r().g9h_1.h7y_1.p7z_1;
  tmp_1.y1w(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.j9r().g9h_1.h7y_1.q7z_1;
  tmp_2.y1w(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.j9r();
  tmp_3.nb6(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.s87_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.g85() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.q9u();
  var tmp1_colMul = $ctx.g7y_1;
  var tmp2_blendMode = Companion_getInstance_13().y7w_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.f88();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().z62();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.v1v_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7_0(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.ub6(elapsedTime);
        $shortWindow.ub6(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.u9g_1.u86();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.sb6(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_35().d1f() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.g9h_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.j87_1;
    if (!(this_2.l7y_1 === this_1)) {
      this_2.l7y_1 = this_1;
      this_2.v7z();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.v87_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().y7w_1;
          var doUpdate = !(this_1.u87_1 === blending);
          var old = this_1.u87_1;
          try {
            if (doUpdate) {
              this_1.j87_1.v7z();
              this_1.u87_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().c43_1;
            var oldColor = this_1.m87_1;
            this_1.m87_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.a88(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.a88(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.m87_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().m3x_1 : Colors_getInstance().n3x_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.m87_1;
                this_1.m87_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.d1() / $longWindow.ob6_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.d1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.d1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.d1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.tb6(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.tb6(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.a88(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.m87_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.j87_1.v7z();
            }
            this_1.u87_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.v87_1;
  }, function (value) {
    $b0.v87_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.db9_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.eb9_1 : tmp0_elvis_lhs);
}
function ensure($this) {
  if ($this.kb9_1.k3_1 === 2) {
    if (!($this.db9_1 == null)) {
      var tmp1_safe_receiver = $this.db9_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.wad();
      }
      $this.db9_1 = null;
    }
    if ($this.eb9_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.kbc(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).u4k();
      this_0.lbc(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.mbc($this.fb9_1);
      this_1.lbb_1 = $this.ib9_1;
      this_1.nbb_1 = $this.hb9_1;
      this_1.lbc($this.jb9_1);
      tmp.eb9_1 = this_1;
    }
  } else {
    if (!($this.eb9_1 == null)) {
      var tmp2_safe_receiver = $this.eb9_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.wad();
      }
      $this.eb9_1 = null;
    }
    if ($this.db9_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.ib4(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).u4k();
      this_2.jb4(tmp$ret$9);
      if (false) {
        this_2.bap();
      }
      this_2.zal_1 = true;
      this_2.lad();
      this_2.bap();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.cb4_1 = $this.fb9_1;
      this_2.ral_1 = $this.ib9_1;
      this_2.gar_1 = $this.hb9_1;
      this_2.jb4($this.jb9_1);
      tmp_0.db9_1 = this_2;
    }
    var tmp3_safe_receiver = $this.db9_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.zao($this.kb9_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.ebf($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.xh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.dap(tmp_0);
    $this.fac(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.dap(tmp$ret$0);
      $this.fac(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.cbf_1.ebf(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.oao_1.c1k();
  if (!(source == null)) {
    $this.nao_1 = true;
    $this.tar(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.qbf();
  }, function (value) {
    return $b0.pbf(value);
  });
}
function updateGraphics_0($this) {
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  // Inline function 'korlibs.korge.view.RoundRect.updateGraphics.<anonymous>' call
  var $this$updatePath = $this.yau_1;
  $this$updatePath.y2();
  $this$updatePath.b3o(new RoundRectangle(new Rectangle(0.0, 0.0, $this.w2i(), $this.x2i()), $this.vax()));
  $this$updatePath.n3e_1 = true;
  $this.uau_1 = $this.yau_1;
  $this.xax();
}
function RoundRect$unscaledSize$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function RoundRect$radius$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function colorMul$factory_0($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.a4d());
  }, function (value) {
    return $b0.y4c(value.i4d_1);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.va7();
  }, function (receiver, value) {
    return receiver.ua7(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.va7();
  }, function (receiver, value) {
    return receiver.ua7(value);
  });
}
function radius$factory_1() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.vax();
  }, function (receiver, value) {
    return receiver.rbi(value);
  });
}
function radius$factory_2() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.vax();
  }, function (receiver, value) {
    return receiver.rbi(value);
  });
}
function color$factory_1() {
  return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.o53());
  }, function (receiver, value) {
    return receiver.bay(value.i4d_1);
  });
}
function color$factory_2() {
  return getPropertyCallableRef('color', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.o53());
  }, function (receiver, value) {
    return receiver.bay(value.i4d_1);
  });
}
var Companion_instance_20;
function Companion_getInstance_42() {
  return Companion_instance_20;
}
function anchor$factory($b0) {
  return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
    return $b0.mar();
  }, function (value) {
    return $b0.iaj(value);
  });
}
function antialiased$factory($b0) {
  return getPropertyCallableRef('antialiased', 0, KMutableProperty0, function () {
    return $b0.fb9_1;
  }, function (value) {
    return $b0.mbc(value);
  });
}
function autoScaling$factory($b0) {
  return getPropertyCallableRef('autoScaling', 0, KMutableProperty0, function () {
    return $b0.ib9_1;
  }, function (value) {
    return $b0.rbc(value);
  });
}
function renderer$factory($b0) {
  return getPropertyCallableRef('renderer', 0, KMutableProperty0, function () {
    return $b0.kb9_1;
  }, function (value) {
    return $b0.sbc(value);
  });
}
function smoothing$factory($b0) {
  return getPropertyCallableRef('smoothing', 0, KMutableProperty0, function () {
    return $b0.hb9_1;
  }, function (value) {
    return $b0.qbc(value);
  });
}
function boundsIncludeStrokes$factory($b0) {
  return getPropertyCallableRef('boundsIncludeStrokes', 0, KMutableProperty0, function () {
    return $b0.pbc();
  }, function (value) {
    return $b0.par(value);
  });
}
function anchor$factory_0() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.mar();
  }, function (receiver, value) {
    return receiver.iaj(value);
  });
}
function anchor$factory_1() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.mar();
  }, function (receiver, value) {
    return receiver.iaj(value);
  });
}
var Companion_instance_21;
function Companion_getInstance_43() {
  return Companion_instance_21;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.s9h_1;
  }, function (value) {
    $b0.s9h_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.bbl();
  }, function (value) {
    return $b0.cbl(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.c5r();
  }, function (receiver, value) {
    return receiver.abl(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.c5r();
  }, function (receiver, value) {
    return receiver.abl(value);
  });
}
function unscaledSize$factory_1() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.va7();
  }, function (receiver, value) {
    return receiver.ua7(value);
  });
}
function unscaledSize$factory_2() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.va7();
  }, function (receiver, value) {
    return receiver.ua7(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.u4e()) {
    case 'msdf':
      return MsdfRender_getInstance().xae_1;
    case 'psdf':
      return MsdfRender_getInstance().aaf_1;
    case 'sdf':
      return MsdfRender_getInstance().aaf_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  var tmp = $this.dbl_1.bbp(ensureNotNull(get_views($this.ebl_1)).e9h_1, $this.fbl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_22;
function Companion_getInstance_44() {
  return Companion_instance_22;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.p1m();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.sbn_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.ebp(sourceFile);
  $this.fbo_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.xh('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.fbp(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.bl();
  var y = pos.cl();
  if ($this.kbo_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.cbo_1.k4n_1, $this.jbo_1.o26_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.cbo_1.l4n_1, $this.jbo_1.p26_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.dbo_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.xbn_1;
  }, function (value) {
    return $b0.ibp(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.ibo_1;
  }, function (value) {
    return $b0.ebp(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.s4e();
  }, function (receiver, value) {
    return receiver.y5o(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.s4e();
  }, function (receiver, value) {
    return receiver.y5o(value);
  });
}
var Companion_instance_23;
function Companion_getInstance_45() {
  return Companion_instance_23;
}
function updateRenderColorTransform($this) {
  $this.g9k_1 = $this.l9k_1;
  $this.n9k_1 = true;
  var parent = $this.n24();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.f9k_1.b4d($this.e9k_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.f9k_1.c4d($this.e9k_1, parent.had());
    } else {
      $this.f9k_1.b4d($this.e9k_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.g9k_1 === $this.l9k_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.i9k_1 = $this.k9k_1;
  $this.m9k_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.k9j_1.equals(Companion_getInstance_13().p7w_1)) {
    var tmp1_safe_receiver = $this.n24();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.iad();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().o7w_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.k9j_1;
  }
  tmp.h9k_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.i9k_1 === $this.k9k_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.s1v() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.y64(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_24;
  return _this__u8e3s4.y64(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.n24();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.lac(Scale.z2d(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.l28(x, y));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.i1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.y9i_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.taa();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.d1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.f1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function addFixedUpdater(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
  first = first === VOID ? true : first;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  return addFixedUpdater_0(_this__u8e3s4, get_fast(time), first, limitCallsPerFrame, updatable);
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.n24();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.n24();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.n24();
  }
  return count;
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.d4q(p);
  return _this__u8e3s4;
}
function size(_this__u8e3s4, size) {
  _this__u8e3s4.rac(size);
  return _this__u8e3s4;
}
function addFixedUpdater_0(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
  first = first === VOID ? true : first;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  var accum = {_v: new FastDuration(Companion_instance_1.s1v())};
  return addFastUpdater(_this__u8e3s4, first, time, addFixedUpdater$lambda(accum, time, updatable, _this__u8e3s4, limitCallsPerFrame));
}
function positionY(_this__u8e3s4, y) {
  _this__u8e3s4.cac(y);
  return _this__u8e3s4;
}
function zIndex(_this__u8e3s4, index) {
  _this__u8e3s4.dac(index);
  return _this__u8e3s4;
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.aac(x, y);
  return _this__u8e3s4;
}
function positionX(_this__u8e3s4, x) {
  _this__u8e3s4.bac(x);
  return _this__u8e3s4;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.i8i_1, $this_addFastUpdater.zab())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.qbp_1, new Duration(Duration__times_impl_sfuzvp(it.sbp(), $this_addUpdaterWithViews.zab())));
    return Unit_instance;
  };
}
function addFixedUpdater$lambda($accum, $time, $updatable, $this_addFixedUpdater, $limitCallsPerFrame) {
  return function ($this$addFastUpdater, dt) {
    $accum._v = new FastDuration(FastDuration__plus_impl_q1enab($accum._v.v1v_1, dt.v1v_1));
    var calls = 0;
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7_0($accum._v.v1v_1, FastDuration__times_impl_h6amcp($time, 0.75)) >= 0) {
      $accum._v = new FastDuration(FastDuration__minus_impl_evs237($accum._v.v1v_1, $time));
      $updatable($this_addFixedUpdater);
      calls = calls + 1 | 0;
      if (calls >= $limitCallsPerFrame) {
        $accum._v = new FastDuration(Companion_instance_1.s1v());
        break $l$loop;
      }
    }
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.gac();
  }, function (value) {
    return $b0.fac(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.oab();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.v87_1;
  }, function (value) {
    $b0.v87_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_19($this, $completion) {
  var tmp = $this.tbp_1.nbf(ensureNotNull(get_views($this.ubp_1)), VOID, $this.vbp_1.gbf_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_20($this, $completion) {
  var tmp = $this.xbp_1.ybp($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.c9h_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().n7w();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.p9h_1;
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.f1(_unary__edvuaz).i1q($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.p9h_1.y2();
  cancel($this.h9g_1);
  $this.n9g_1.q8g();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.s9f(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.p9g_1 == null) ? ensureNotNull(this$0.p9g_1) : StandardPaths_instance.i2y(this$0.zbp());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.r1j();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.g9h_1.y83();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.g9h_1.o88();
    return Unit_instance;
  };
}
var Companion_instance_24;
function Companion_getInstance_46() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_47() {
  return Companion_instance_25;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.y9g_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.i8i_1 = delta;
  _this__u8e3s4.j65(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.z9g_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.rbp_1 = delta;
  _this__u8e3s4.j65(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().q2g() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_25().p25() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.t2q(reqVirtualSize_0);
  targetSize.t2q(scaleMode.t2g(virtualSize.o1(), actualSize_0));
  var ratioX = targetSize.o1().b2h_1 / reqVirtualSize_0.b2h_1;
  var ratioY = targetSize.o1().c2h_1 / reqVirtualSize_0.c2h_1;
  var actualVirtualWidth = toIntRound(actualSize_0.b2h_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.c2h_1 / ratioY);
  _this__u8e3s4.x86(Companion_getInstance_30().n29_1.r2a(ratioX, ratioY).z2a(toIntRound((actualVirtualWidth - reqVirtualSize_0.b2h_1 | 0) * anchor.m25_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.c2h_1 | 0) * anchor.n25_1)));
  _this__u8e3s4.t86(_this__u8e3s4.y86().c2b());
  _this__u8e3s4.z86(_this__u8e3s4.y86().d2b());
  _this__u8e3s4.v86(_this__u8e3s4.u86().d2b());
  var tl = _this__u8e3s4.e87(Vector2D.y28(0, 0));
  var br = _this__u8e3s4.e87(Vector2D.l28(actualSize_0.b2h_1, actualSize_0.c2h_1));
  _this__u8e3s4.b87(Companion_getInstance_28().p2e(tl.c26_1, tl.d26_1, br.c26_1, br.d26_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.m62(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.d88();
  }, function (value) {
    return $b0.k8g(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.u8g();
  }, function (value) {
    return $b0.t8g(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.f7y_1;
  }, function (value) {
    $b0.f7y_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.g7y_1);
  }, function (value) {
    $b0.g7y_1 = value.i4d_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.i8e_1;
  }, function (value) {
    $b0.i8e_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.l9o();
  }, function (receiver, value) {
    return receiver.r9o(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.l9o();
  }, function (receiver, value) {
    return receiver.r9o(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ebq();
  }, function (receiver, value) {
    return receiver.h9o(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ebq();
  }, function (receiver, value) {
    return receiver.h9o(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.fbq());
  }, function (receiver, value) {
    return receiver.i9o(value.i4d_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.fbq());
  }, function (receiver, value) {
    return receiver.i9o(value.i4d_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.c9i_1;
  }, function (value) {
    $b0.c9i_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.e9i_1;
  }, function (value) {
    $b0.e9i_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.lbq();
  }, function (receiver, value) {
    return receiver.sbq(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.lbq();
  }, function (receiver, value) {
    return receiver.sbq(value);
  });
}
function alignLeftToLeftOf(_this__u8e3s4, other, padding) {
  return alignLeftToLeftOf_0(_this__u8e3s4, other, padding);
}
function centerOn(_this__u8e3s4, other) {
  return centerYOn(centerXOn(_this__u8e3s4, other), other);
}
function alignRightToRightOf(_this__u8e3s4, other, padding) {
  return alignRightToRightOf_0(_this__u8e3s4, other, padding);
}
function centerOnStage(_this__u8e3s4) {
  return centerYOnStage(centerXOnStage(_this__u8e3s4));
}
function alignRightToLeftOf(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 0.0, false, padding);
}
function centerXOnStage(_this__u8e3s4) {
  return centerXOn(_this__u8e3s4, _this__u8e3s4.h24());
}
function centerXBetween(_this__u8e3s4, x1, x2) {
  return centerXBetween_0(_this__u8e3s4, x1, x2);
}
function centerYOn(_this__u8e3s4, other) {
  return alignY(_this__u8e3s4, other, 0.5, true);
}
function alignLeftToLeftOf_0(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 0.0, true, padding);
}
function alignLeftToRightOf(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 1.0, false, padding);
}
function centerXOn(_this__u8e3s4, other) {
  return alignX(_this__u8e3s4, other, 0.5, true);
}
function centerYBetween(_this__u8e3s4, y1, y2) {
  _this__u8e3s4.cac((y2 + y1 - _this__u8e3s4.x2i()) / 2);
  return _this__u8e3s4;
}
function centerYOnStage(_this__u8e3s4) {
  return centerYOn(_this__u8e3s4, _this__u8e3s4.h24());
}
function alignRightToRightOf_0(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 1.0, true, padding);
}
function alignX(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, true, padding);
}
function centerXBetween_0(_this__u8e3s4, x1, x2) {
  _this__u8e3s4.bac((x2 + x1 - _this__u8e3s4.w2i()) / 2);
  return _this__u8e3s4;
}
function alignY(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, false, padding);
}
function alignXY(_this__u8e3s4, other, ratio, inside, doX, padding) {
  padding = padding === VOID ? 0.0 : padding;
  var bounds = other.hae(_this__u8e3s4.n24());
  var localBounds = _this__u8e3s4.n9u();
  var ratioM1_1 = ratio * 2 - 1;
  var rratioM1_1 = inside ? ratioM1_1 : -ratioM1_1;
  var iratio = inside ? ratio : 1.0 - ratio;
  if (doX) {
    _this__u8e3s4.bac(bounds.m26_1 + bounds.o26_1 * ratio - localBounds.t26() - _this__u8e3s4.wac() * iratio - padding * rratioM1_1);
  } else {
    _this__u8e3s4.cac(bounds.n26_1 + bounds.p26_1 * ratio - localBounds.v26() - _this__u8e3s4.xac() * iratio - padding * rratioM1_1);
  }
  return _this__u8e3s4;
}
var renderToTextureResultPool$delegate;
var Companion_instance_26;
function Companion_getInstance_48() {
  if (Companion_instance_26 === VOID)
    new Companion_11();
  return Companion_instance_26;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.l2f(getBorder(_this__u8e3s4, toIntCeil(inp.o26_1), toIntCeil(inp.p26_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.wbq(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.k2p(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.ov();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_27;
function Companion_getInstance_49() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.q9k_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.kbr_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.e1j_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.c1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.n9u(VOID, false);
  if (bounds.o26_1 <= 0.0 || bounds.p26_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_48();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.vbq();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.ubq(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.o26_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.p26_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.o26_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.m26_1 + edgeSize;
  var addy = -bounds.n26_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.v7z();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.q88(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.s88(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.h7y_1;
      var this_1 = this_0.q7y_1;
      if (!(this_1.l7y_1 === this_0)) {
        this_1.l7y_1 = this_0;
        this_1.v7z();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.l6o(0, 0, rb.o6d_1, rb.p6d_1);
        var temp = this_0.o7z_1;
        this_0.y85();
        this_0.o7z_1 = scissor;
        try {
          if (true) {
            ctx.l88(Colors_getInstance().r3x_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.gad().v2a(addx, addy).q2a(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.h7y_1.q7y_1;
          this_2.v7z();
          var temp4 = this_2.w7x_1;
          var temp2d = this_2.x7x_1;
          this_2.x7x_1 = mat;
          this_2.w7x_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.x6k(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.m6m();
            this_3.d79(_unary__edvuaz + 1 | 0);
            this_3.e79(this_3.m6m() + 1 | 0);
            var blockSize = this_3.q6k_1;
            var index0 = imul(this_3.m6m() - 1 | 0, blockSize);
            var index1 = imul(this_3.m6m(), blockSize);
            var texBlockSize = this_3.n6k_1.m6s().d1();
            var texIndex0 = imul(this_3.m6m() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.m6m(), texBlockSize);
            if (this_3.m6m() > 0) {
              arraycopy(this_3.s6k_1, index0, this_3.s6k_1, index1, blockSize);
            } else {
              arrayfill(this_3.s6k_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.n6k_1;
            this_3.t6k_1.n79($this$push.l6s(), this_2.w7x_1);
            if (true && this_3.m6m() >= 1) {
              var equals = arrayequal(this_3.s6k_1, index0, this_3.s6k_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.m6m();
                this_3.d79(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.oad(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.pad(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.v7z();
            this_2.w7x_1 = temp4;
            this_2.x7x_1 = temp2d;
            this_2.x6k(ProjViewUB_getInstance()).f79();
          }
          break $l$block_0;
        }finally {
          this_0.y85();
          this_0.o7z_1 = temp;
        }
      }
    }finally {
      ctx.t88();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).a3i(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.p9u().z2a(-addx, -addy).s2a(1.0 / realFilterScale);
    filter.xbq(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.jad(), _this__u8e3s4.k9j_1, realFilterScale);
    ctx.v7z();
  }finally {
    ctx.r88(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.q9k_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lbr_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_48().ubq(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.e1j_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.obb_1 ? $this.zbb_1 : $this.ybb_1;
  if (!valid) {
    if ($this.obb_1)
      $this.zbb_1 = true;
    else
      $this.ybb_1 = true;
    var result = $this.wbb_1.u5q($this.obb_1);
    if ($this.obb_1)
      $this.cbc_1 = result;
    else
      $this.bbc_1 = result;
    return result;
  }
  return $this.obb_1 ? $this.cbc_1 : $this.bbc_1;
}
function invalidateShape($this) {
  $this.abc_1 = 0;
  $this.xbb_1 = false;
  $this.ybb_1 = false;
  $this.zbb_1 = false;
  $this.qaa();
}
function requireShape($this) {
  if ($this.xbb_1)
    return Unit_instance;
  $this.xbb_1 = true;
  $this.pbb_1.y2();
  $this.pbb_1.wbr();
  $this.pbb_1.xbr(Companion_getInstance_14().h6f_1);
  $this.dbc_1 = true;
  renderShape($this, $this.wbb_1);
  $this.pbb_1.x6d();
  $this.fbc_1 = $this.ebc_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.p9u().e2a(get_immutable(ctx.k7x_1.y86())) : $this.p9u();
  $this.gbc_1 = mat.x2a(-$this.pab(), -$this.qab());
  requireShape($this);
  $this.pbb_1.ybr(ctx, $this.gbc_1, $this.fad(), $this.tbb_1, $this.jad(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.h5r_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.k5s());
      } else {
        if (shape instanceof FillShape) {
          $this.abc_1 = $this.abc_1 + 1 | 0;
          if ($this.abc_1 > $this.hbc_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.abc_1 = $this.abc_1 + 1 | 0;
            if ($this.abc_1 > $this.hbc_1)
              return Unit_instance;
            renderStroke$default($this, shape.m5r_1, shape.j5r_1, shape.l5r_1, shape.o5r_1, shape.n5r_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.nd('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.pbb_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.xbr(Companion_getInstance_14().h6f_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.d1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.f1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.zbr();
    var vector = points.b39();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.d1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.n28(n_0, 0);
        var y = vector.n28(n_0, 1);
        var dx = vector.n28(n_0, 2);
        var dy = vector.n28(n_0, 3);
        var len = vector.n28(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.n28(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.abs(px, py, $this.vbb_1 ? len : 0.0, $this.vbb_1 ? maxLen : $this.jbc_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.bbs();
    var info = GpuShapeViewPrograms_getInstance().ubs(stateTransform, paint, globalAlpha, strokeInfo.k38_1);
    var tmp0_drawType = Companion_getInstance_16().j6n_1;
    var tmp1_blendMode = Companion_getInstance_13().o7w_1;
    gpuShapeViewCommands.vbs(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().v6e_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_18().t6e_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.d1() < 3)
    return null;
  var vertexStart = $this.pbb_1.zbr();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_29().c27(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.l28(xMid, yMid);
  var isStrip = type === Companion_getInstance_16().j6n_1;
  var antialiased = $this.vbb_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.pbb_1.abs(xMid, yMid, 0.0, $this.jbc_1);
  }
  var inductionVariable = 0;
  var last = points.d1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.f1(n % points.d1() | 0);
      var x = p.bl();
      var y = p.cl();
      var len = isStripAndAntialiased ? Companion_getInstance_27().m2h(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.jbc_1;
      if (isStrip) {
        $this.pbb_1.abs(xMid, yMid, 0.0, maxLen);
      }
      $this.pbb_1.abs(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.pbb_1.bbs();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.d1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.i1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().ubs(shape.y5q_1, shape.x5q_1, shape.z5q_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.ibc_1;
  var drawAntialiasingBorder = $this.ibc_1 ? true : $this.vbb_1;
  var shapeIsConvex = shape.f5r();
  var isSimpleDraw = shapeIsConvex && shape.w5q_1 == null && !$this.ibc_1;
  var pathDataList = getPointsForPathList($this, shape.v5q_1, isSimpleDraw ? Companion_getInstance_16().j6n_1 : Companion_getInstance_16().k6n_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_29().c27();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.d1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.f1(_unary__edvuaz);
    bb = plus(bb, it.wbs_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.l2f(MarginInt.j29(2)));
  var clipDataStart = $this.pbb_1.zbr();
  var tmp1_safe_receiver = shape.w5q_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_16().k6n_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.pbb_1.bbs();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.wbs_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_14().h6f_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.dbc_1) {
    $this.dbc_1 = true;
    $this.pbb_1.xbr(isSimpleDraw ? Companion_getInstance_14().h6f_1 : !clipBounds.equals(Companion_getInstance_14().h6f_1) ? Companion_getInstance_14().q6o(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.dbc_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.d1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.f1(_unary__edvuaz_0);
      var tmp0_$this = $this.pbb_1;
      var tmp1_drawType = Companion_getInstance_16().j6n_1;
      var tmp2_startIndex = pathData.ybs_1;
      var tmp3_endIndex = pathData.zbs_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.iad();
      tmp0_$this.vbs(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.v5q_1.l3e_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_19().k6p_1;
  if (drawFill) {
    switch (winding.k3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_19().k6p_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), Companion_getInstance_19().j6p_1), Companion_getInstance_20().v6p_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().t6e_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.d1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.f1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.ybs_1, pathData_0.zbs_1, stencilOpFunc, stencilRef, Companion_getInstance_21().j6f_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_19().q6p_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), Companion_getInstance_19().j6p_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().t6e_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.d1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.f1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.ybs_1, pathData_1.zbs_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_20().u6p_1, Companion_getInstance_20().s6p_1), stencilRef_0, Companion_getInstance_21().j6f_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), Companion_getInstance_19().q6p_1), Companion_getInstance_20().v6p_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_18().t6e_1, 0), 255), Companion_getInstance_21().k6f_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), Companion_getInstance_19().j6p_1), Companion_getInstance_20().v6p_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().t6e_1, 2), Companion_getInstance_21().m6f_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.w5q_1 == null) {
    renderStroke($this, shape.y5q_1, shape.v5q_1, shape.x5q_1, shape.z5q_1, new StrokeInfo(1.6 / $this.ebc_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_17().v6e_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().t6e_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.pbb_1.r73(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.pbb_1;
  var tmp1_drawType = Companion_getInstance_16().k6n_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().tbs_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().q7w_1;
  tmp0_$this.abt(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.pbb_1.zbr();
  var x0 = pathBounds.t26();
  var y0 = pathBounds.v26();
  var x1 = pathBounds.u26();
  var y1 = pathBounds.w26();
  $this.pbb_1.abs(x0, y0, 0.0, $this.jbc_1);
  $this.pbb_1.abs(x1, y0, 0.0, $this.jbc_1);
  $this.pbb_1.abs(x1, y1, 0.0, $this.jbc_1);
  $this.pbb_1.abs(x0, y1, 0.0, $this.jbc_1);
  var vend = $this.pbb_1.bbs();
  var tmp0_$this = $this.pbb_1;
  var tmp1_drawType = Companion_getInstance_16().k6n_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().v6e_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().t6e_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.iad();
  tmp0_$this.vbs(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.y6u(), GpuShapeViewPrograms_getInstance().gbu());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.y6u(), $this$IF_ELSE_LIST.g6v($$this$FragmentShaderDefault.f6v(), $this$IF_ELSE_LIST.m6w($this$IF_ELSE_LIST.o6w([$this$IF_ELSE_LIST.e6v($this$IF_ELSE_LIST.z6u(GpuShapeViewPrograms_getInstance().ibu(), $this$IF_ELSE_LIST.c6v([$$this$FragmentShaderDefault.r6u(), $this$IF_ELSE_LIST.b6v(0.0), $this$IF_ELSE_LIST.b6v(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.y6u(), $this$IF_ELSE_LIST.g6v($$this$FragmentShaderDefault.f6v(), $this$IF_ELSE_LIST.e6v($this$IF_ELSE_LIST.z6u(GpuShapeViewPrograms_getInstance().ibu(), $this$IF_ELSE_LIST.c6v([$this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.b6v(0.0), $this$IF_ELSE_LIST.b6v(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.g6w(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.e6v(rpoint, 'xy'), $this$IF_ELSE_LIST.e6v($this$IF_ELSE_LIST.z6u(GpuShapeViewPrograms_getInstance().ibu(), $this$IF_ELSE_LIST.c6v([$this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.b6v(0.0), $this$IF_ELSE_LIST.b6v(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.p6w(rpoint);
        var y = $this$IF_ELSE_LIST.q6w(rpoint);
        var x0 = $this$IF_ELSE_LIST.p6w(GpuShapeViewPrograms_getInstance().jbu());
        var y0 = $this$IF_ELSE_LIST.q6w(GpuShapeViewPrograms_getInstance().jbu());
        var r0 = $this$IF_ELSE_LIST.r6w(GpuShapeViewPrograms_getInstance().jbu());
        var x1 = $this$IF_ELSE_LIST.p6w(GpuShapeViewPrograms_getInstance().kbu());
        var y1 = $this$IF_ELSE_LIST.q6w(GpuShapeViewPrograms_getInstance().kbu());
        var r1 = $this$IF_ELSE_LIST.r6w(GpuShapeViewPrograms_getInstance().kbu());
        var ratio = $this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.j6v());
        var r0r1_2 = $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.j6v());
        var r0pow2 = $this$IF_ELSE_LIST.r6w($$this$FragmentShaderDefault.j6v());
        var r1pow2 = $this$IF_ELSE_LIST.s6w($$this$FragmentShaderDefault.j6v());
        var y0_y1 = $this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.a6x());
        var x0_x1 = $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.a6x());
        var r0_r1 = $this$IF_ELSE_LIST.r6w($$this$FragmentShaderDefault.a6x());
        var radial_scale = $this$IF_ELSE_LIST.s6w($$this$FragmentShaderDefault.a6x());
        $this$IF_ELSE_LIST.v6u(r0r1_2, $this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.b6v(2.0), r0), r1));
        $this$IF_ELSE_LIST.v6u(r0pow2, GpuShapeViewPrograms_getInstance().lbu(r0));
        $this$IF_ELSE_LIST.v6u(r1pow2, GpuShapeViewPrograms_getInstance().lbu(r1));
        $this$IF_ELSE_LIST.v6u(x0_x1, $this$IF_ELSE_LIST.u6w(x0, x1));
        $this$IF_ELSE_LIST.v6u(y0_y1, $this$IF_ELSE_LIST.u6w(y0, y1));
        $this$IF_ELSE_LIST.v6u(r0_r1, $this$IF_ELSE_LIST.u6w(r0, r1));
        $this$IF_ELSE_LIST.v6u(radial_scale, $this$IF_ELSE_LIST.k6v($this$IF_ELSE_LIST.b6v(1.0), $this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.u6w(GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(r0, r1)), GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(x0, x1))), GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(y0, y1)))));
        $this$IF_ELSE_LIST.v6u(ratio, $this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.b6v(1.0), $this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.t6w(r1), r0_r1), $this$IF_ELSE_LIST.z6u(x0_x1, $this$IF_ELSE_LIST.u6w(x1, x))), $this$IF_ELSE_LIST.z6u(y0_y1, $this$IF_ELSE_LIST.u6w(y1, y))), $this$IF_ELSE_LIST.k6w($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.z6u(r1pow2, $this$IF_ELSE_LIST.v6w(GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(x0, x)), GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(y0, y)))), $this$IF_ELSE_LIST.z6u(r0r1_2, $this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.u6w(x0, x), $this$IF_ELSE_LIST.u6w(x1, x)), $this$IF_ELSE_LIST.z6u($this$IF_ELSE_LIST.u6w(y0, y), $this$IF_ELSE_LIST.u6w(y1, y))))), $this$IF_ELSE_LIST.z6u(r0pow2, $this$IF_ELSE_LIST.v6w(GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(x1, x)), GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w(y1, y))))), GpuShapeViewPrograms_getInstance().lbu($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.v6w($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.u6w($this$IF_ELSE_LIST.z6u(x1, y0), $this$IF_ELSE_LIST.z6u(x, y0)), $this$IF_ELSE_LIST.z6u(x0, y1)), $this$IF_ELSE_LIST.z6u(x, y1)), $this$IF_ELSE_LIST.z6u(x0, y)), $this$IF_ELSE_LIST.z6u(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.y6u(), $this$IF_ELSE_LIST.g6v($$this$FragmentShaderDefault.f6v(), $this$IF_ELSE_LIST.o6w([ratio, $this$IF_ELSE_LIST.b6v(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.g6w(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.e6v(rpoint_0, 'xy'), $this$IF_ELSE_LIST.e6v($this$IF_ELSE_LIST.z6u(GpuShapeViewPrograms_getInstance().ibu(), $this$IF_ELSE_LIST.c6v([$this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.r6u()), $this$IF_ELSE_LIST.b6v(0.0), $this$IF_ELSE_LIST.b6v(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.p6w(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.q6w(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.p6w($$this$FragmentShaderDefault.j6v());
        var angle = $this$IF_ELSE_LIST.q6w($$this$FragmentShaderDefault.j6v());
        var x0_0 = $this$IF_ELSE_LIST.p6w(GpuShapeViewPrograms_getInstance().jbu());
        var y0_0 = $this$IF_ELSE_LIST.q6w(GpuShapeViewPrograms_getInstance().jbu());
        var PI2 = $this$IF_ELSE_LIST.b6v(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.v6u(angle, $this$IF_ELSE_LIST.i6w($this$IF_ELSE_LIST.u6w(y_0, y0_0), $this$IF_ELSE_LIST.u6w(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.x6w(angle, $this$IF_ELSE_LIST.b6v(0.0));
        var body = $this$IF_ELSE_LIST.m6v();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.v6u(angle, body.v6w(angle, PI2));
        var stmIf = new If(cond, body.o6v());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.u6u_1.h(stmIf);
        $this$IF_ELSE_LIST.v6u(ratio_0, $this$IF_ELSE_LIST.k6v(angle, PI2));
        $this$IF_ELSE_LIST.v6u($this$IF_ELSE_LIST.y6u(), $this$IF_ELSE_LIST.g6v($$this$FragmentShaderDefault.f6v(), $this$IF_ELSE_LIST.m6w($this$IF_ELSE_LIST.o6w([ratio_0, $this$IF_ELSE_LIST.b6v(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.fbu();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.gbu();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ebu();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.hbu();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.dbu();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.ibu();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.jbu();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.kbu();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.fbu();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.gbu();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.ebu();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.hbu();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.dbu();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.ibu();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.jbu();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.kbu();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragInfo, 'MouseDragInfo');
initMetadataForClass(OnMouseDragCloseable, 'OnMouseDragCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragState, 'MouseDragState');
initMetadataForClass(DraggableCloseable, 'DraggableCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForClass(DraggableInfo, 'DraggableInfo');
initMetadataForLambda(onMouseDragInternal$slambda, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(onMouseDragInternal$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(onMouseDragInternal$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.xar);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.g9y);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.yar);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.haj);
initMetadataForClass(UIView, 'UIView', UIView.pa7);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.qa7);
protoOf(Transition$1).mae = start;
protoOf(Transition$1).nae = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForClass(UIObservable, 'UIObservable');
initMetadataForCompanion(Companion_3);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.sbf);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(ShapeView, 'ShapeView', ShapeView.zax);
initMetadataForClass(Circle_0, 'Circle', Circle_0.yax);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.ib4);
initMetadataForClass(DummyView, 'DummyView', DummyView.kb6);
initMetadataForCompanion(Companion_4);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.mb6);
initMetadataForClass(SContainer, 'SContainer', SContainer.ua0);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.nbc);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).nbf = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(RoundRect, 'RoundRect');
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_7);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_8);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).nbf = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_11);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).vbq = get_recommendedFilterScale;
protoOf(IdentityFilter).wbq = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.kbc);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_16 = new Companion_1();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
//endregion
//region block: exports
export {
  GraphicsRenderer_GPU_getInstance as GraphicsRenderer_GPU_getInstance3l98mt1a5bjlb,
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_39 as Companion_getInstance2b4rje0hs8ulh,
  Companion_instance_22 as Companion_instance1qzytx5vkv693,
  draggableCloseable as draggableCloseable19eszn4jr7had,
  get_mouse as get_mouse1jstwhfaumelj,
  onMouseDrag as onMouseDrag20om3ch85u2pf,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  alignLeftToLeftOf as alignLeftToLeftOf1gd7pnuyw0xa7,
  alignLeftToLeftOf_0 as alignLeftToLeftOfjh6f4sjag42i,
  alignLeftToRightOf as alignLeftToRightOf25wtg1v682ku8,
  alignRightToLeftOf as alignRightToLeftOf3v4uhguhiuzzk,
  alignRightToRightOf as alignRightToRightOf3d4tb0coiq6gi,
  centerOnStage as centerOnStage1tf2oda60yrak,
  centerOn as centerOnqo5dp4jcubi5,
  centerXBetween as centerXBetweenqjpl7rjhq6xz,
  centerXOnStage as centerXOnStage2bkj8bzlu32ll,
  centerXOn as centerXOn3acn3bw226nj3,
  centerYBetween as centerYBetweenlw6rnmefjppz,
  centerYOnStage as centerYOnStage363rojcpfesqp,
  centerYOn as centerYOnkz3i3jt5wqfb,
  Circle_0 as Circlepba9jsmewo4k,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  RoundRect as RoundRect16qm0yoxjizxs,
  SolidRect as SolidRect131p7hyzlx7j8,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addFixedUpdater as addFixedUpdater1i013etalwvod,
  addTo as addTo25e29vq105prw,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  positionX as positionX2hf0c1pfbo3wz,
  positionY as positionY2uokil6y98hyo,
  position as positionu6441b7hkb4l,
  scale as scalea9fc0mbrr7ub,
  xy_0 as xy1gb51vhy014mx,
  zIndex as zIndex304xgfufia3na,
};
//endregion
